// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --lkfr-bg: #f5f6f8;
  --lkfr-surface: #fff;
  --lkfr-ink: #232737;
  --lkfr-muted: #657085;
  --lkfr-border: #e4e8ee;
  --lkfr-accent: #e72f44;
  --lkfr-accent-soft: #fff0f2;
  --lkfr-success: #14764d;
  --lkfr-radius: 18px;
  --lkfr-sidebar-width: 264px;
}

body {
  background: var(--lkfr-bg);
  font-family: "Cera Pro", Arial, sans-serif;
  color: var(--lkfr-ink);
}

.lkfr-app {
  --lkfr-header-height: 75px;
  min-height: 100dvh;
  color: var(--lkfr-ink);
  font-family: "Cera Pro", Arial, sans-serif;
}
.lkfr-app *, .lkfr-app *::before, .lkfr-app *::after {
  box-sizing: border-box;
}
.lkfr-app button, .lkfr-app input, .lkfr-app select, .lkfr-app textarea {
  font-family: inherit;
}
.lkfr-app button, .lkfr-app a {
  -webkit-tap-highlight-color: transparent;
}
.lkfr-app button {
  cursor: pointer;
}
.lkfr-app button:disabled {
  cursor: default;
  opacity: 0.55;
}
.lkfr-app :is(button, a, input, select, textarea, summary):focus-visible {
  outline: 3px solid #5365cc;
  outline-offset: 3px;
}
.lkfr-app h1 {
  font-size: clamp(26px, 2.6vw, 34px);
  line-height: 1.15;
  letter-spacing: -0.035em;
  font-weight: 700;
}
.lkfr-app h2 {
  line-height: 1.25;
  letter-spacing: -0.02em;
}
.lkfr-app p {
  line-height: 1.55;
}

.lkfr-workspace {
  min-width: 0;
}

.lkfr-content {
  width: min(100%, 1328px);
  margin: auto;
  padding: 32px;
}

.lkfr-shell-header {
  position: sticky;
  top: 0;
  z-index: 90;
  background: #fff;
  border-bottom: 1px solid var(--lkfr-border);
}

.lkfr-app .app-header {
  width: 100%;
  max-width: none;
  margin: 0;
  min-height: 74px;
  padding: 12px 32px;
  border-radius: 0;
  box-shadow: none;
  background: transparent;
}

.lkfr-app .header-menu {
  flex: 0 0 auto;
  width: 40px;
  height: 44px;
}

.lkfr-app .header-logo-group {
  border: 0;
  background: transparent;
  padding: 0;
  font: inherit;
  flex: 1 1;
  min-width: 0;
  min-height: 44px;
  justify-content: center;
  text-align: center;
}

.lkfr-app .header-address-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 0;
  max-width: 100%;
  color: var(--lkfr-muted);
  font-size: 11px;
  line-height: 1.5;
  letter-spacing: 0.015em;
}

.lkfr-app .header-address-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 0;
  max-width: 100%;
}

.lkfr-app .header-address {
  display: block;
  min-width: 0;
  max-width: 680px;
  margin: 0;
  font-size: 15px;
  font-weight: 500;
  color: var(--lkfr-ink);
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.lkfr-app .header-arrow {
  display: block;
  flex: 0 0 16px;
  width: 16px;
  height: 16px;
  margin: 0;
  color: var(--lkfr-muted);
  transition: transform 0.18s ease;
}

.lkfr-app .header-logo-group[aria-expanded=true] .header-arrow {
  transform: rotate(180deg);
}

.lkfr-app .header-bell {
  box-shadow: none;
  border: 1px solid var(--lkfr-border);
  border-radius: 12px;
  width: 42px;
  height: 42px;
}

.lkfr-app .header-bell-badge {
  top: -5px;
  right: -5px;
  box-shadow: none;
}

.lkfr-app .header-load-error {
  margin: 12px 24px;
}

.lkfr-sidebar {
  position: fixed;
  inset: 0 auto 0 0;
  width: var(--lkfr-sidebar-width);
  background: #fff;
  border-right: 1px solid var(--lkfr-border);
  padding: 24px 16px 16px;
  z-index: 110;
  display: flex;
  flex-direction: column;
  transform: translateX(-100%);
  transition: transform 0.2s ease;
}

.lkfr-sidebar.open {
  transform: none;
}

.lkfr-brand {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 14px 22px;
  text-decoration: none;
  flex: 0 0 auto;
}

.lkfr-brand-mark {
  color: var(--lkfr-accent);
  font-size: 28px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: -0.055em;
}
.lkfr-brand-mark span {
  margin-left: 5px;
}

.lkfr-brand-caption {
  font-size: 11px;
  color: var(--lkfr-muted);
  margin-top: 7px;
}

.lkfr-navigation {
  min-height: 0;
  flex: 1 1;
  display: flex;
}
.lkfr-navigation ul {
  width: 100%;
  margin: 0;
  padding: 0 3px 0 0;
  list-style: none;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: thin;
}

.lkfr-nav-group {
  margin: 0 0 22px;
}

.lkfr-nav-group-label {
  display: block;
  padding: 0 14px 8px;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #7c8595;
}

.lkfr-nav-link {
  display: flex;
  align-items: center;
  gap: 11px;
  min-height: 41px;
  padding: 8px 12px;
  margin: 3px 0;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 500;
  color: #505b6d;
  text-decoration: none;
  transition: background 0.15s, color 0.15s;
}
.lkfr-nav-link svg {
  width: 19px;
  height: 19px;
  flex: 0 0 auto;
  stroke-width: 1.7;
}
.lkfr-nav-link span {
  flex: 1 1;
}
.lkfr-nav-link small {
  color: var(--lkfr-muted);
}
.lkfr-nav-link:hover {
  background: #f4f6f8;
  color: var(--lkfr-ink);
}
.lkfr-nav-link.active {
  background: var(--lkfr-accent-soft);
  color: #bf1e32;
}

.lkfr-nav-profile {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: var(--lkfr-ink);
  padding: 14px 8px 0;
  border-top: 1px solid var(--lkfr-border);
  margin-top: 12px;
}
.lkfr-nav-profile > span:nth-child(2) {
  min-width: 0;
  flex: 1 1;
}
.lkfr-nav-profile strong {
  display: block;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
}
.lkfr-nav-profile small {
  display: block;
  color: var(--lkfr-muted);
  font-size: 11px;
  margin-top: 4px;
}
.lkfr-nav-profile img {
  width: 36px;
  height: 36px;
  border-radius: 12px;
  object-fit: cover;
}

.lkfr-avatar {
  width: 36px;
  height: 36px;
  border-radius: 12px;
  background: #f1f3f7;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 13px;
  flex: 0 0 auto;
}

.lkfr-nav-close {
  position: absolute;
  top: 15px;
  right: 13px;
  border: 0;
  background: #f3f5f7;
  font-size: 24px;
  width: 36px;
  height: 36px;
  border-radius: 10px;
}

.lkfr-nav-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(24, 34, 52, 0.4);
  border: 0;
  z-index: 105;
}

.lkfr-bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: calc(65px + env(safe-area-inset-bottom));
  padding-bottom: env(safe-area-inset-bottom);
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  border-top: 1px solid var(--lkfr-border);
  background: #fff;
  z-index: 95;
}
.lkfr-bottom-nav a, .lkfr-bottom-nav button {
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  border: 0;
  background: transparent;
  color: #717b8c;
  font-size: 10px;
  text-decoration: none;
  font-weight: 500;
}
.lkfr-bottom-nav a svg, .lkfr-bottom-nav button svg {
  width: 21px;
  height: 21px;
}
.lkfr-bottom-nav a.active, .lkfr-bottom-nav button.active {
  color: var(--lkfr-accent);
}

.lkfr-more-icon {
  font-size: 29px;
  line-height: 21px;
  height: 21px;
}

.lkfr-eyebrow {
  color: var(--lkfr-muted);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.lkfr-helper {
  color: var(--lkfr-muted);
  font-size: 13px;
  line-height: 1.55;
}

.lkfr-empty-page {
  text-align: center;
  padding: 80px 16px;
  max-width: 620px;
  margin: auto;
}
.lkfr-empty-page p {
  color: var(--lkfr-muted);
  margin: 20px 0 28px;
}

.lkfr-dialog-overlay {
  position: fixed;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 20px;
  background: rgba(23, 32, 49, 0.4392156863);
  z-index: 5000;
}

.lkfr-dialog {
  background: white;
  padding: 28px;
  border-radius: 20px;
  width: min(100%, 470px);
  color: var(--lkfr-ink);
  font-family: "Cera Pro", Arial, sans-serif;
  box-sizing: border-box;
}
.lkfr-dialog h2 {
  margin: 12px 0;
  font-size: 23px;
}
.lkfr-dialog p, .lkfr-dialog li {
  color: var(--lkfr-muted);
  font-size: 14px;
  line-height: 1.6;
}

.lkfr-dialog-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 24px;
}
.lkfr-dialog-actions button {
  font: inherit;
}

.lkfr-app .address-modal-overlay {
  align-items: center;
  padding: 24px;
}

.lkfr-app .address-modal-sheet {
  max-width: 520px;
  border-radius: 20px;
  box-shadow: none;
  padding: 24px;
}

.lkfr-app .address-modal-title {
  text-align: left;
  font-size: 23px;
}

.lkfr-company-search {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 12px;
  color: var(--lkfr-muted);
  margin-bottom: 14px;
}
.lkfr-company-search input {
  font: inherit;
  font-size: 14px;
  padding: 11px 12px;
  border: 1px solid var(--lkfr-border);
  border-radius: 10px;
}

.lkfr-app .address-modal-list li {
  padding: 0;
}
.lkfr-app .address-modal-list li button {
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  width: 100%;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 13px 12px;
  border-radius: 10px;
}

.lkfr-app .address-modal-close {
  border-radius: 10px;
  font-size: 14px;
  padding: 12px;
}

/* The same page width, form controls and surfaces across both generations. */
.lkfr-app :is(.business-page, .section-page, .support-tickets-page, .design-tickets-page, .terminal-page, .profile-page, .notif-page, .budget-page, .ops-page, .terminal-marking-page) {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0;
  min-height: 0;
  background: transparent;
  font-family: inherit;
}

.lkfr-app :is(.section-title, .support-tickets-title, .design-tickets-title, .terminal-title, .notif-title-page) {
  margin: 0 0 24px;
}

.lkfr-app :is(.business-page > h1, .ops-page > h1) {
  margin: 0 0 10px;
}

.lkfr-app .business-back {
  display: inline-flex;
  margin-bottom: 20px;
  font-size: 12px;
}

.lkfr-app :is(.business-subtitle, .section-helper, .section-stat-label) {
  color: var(--lkfr-muted);
}

.lkfr-app .business-subtitle {
  max-width: 780px;
  font-size: 15px;
  margin: 0 0 26px;
}

.lkfr-app :is(.business-card, .section-card, .terminal-card, .support-ticket-card, .design-ticket-card, .profile-card, .notif-card) {
  border: 1px solid var(--lkfr-border);
  box-shadow: none;
  border-radius: var(--lkfr-radius);
  background: var(--lkfr-surface);
}

.lkfr-app :is(.business-card, .section-card) {
  padding: 24px;
  margin-bottom: 20px;
}

.lkfr-app :is(.business-card h2, .section-subtitle) {
  font-size: 19px;
  font-weight: 600;
}

.lkfr-app :is(.business-toolbar, .section-toolbar) {
  gap: 12px;
}

.lkfr-app :is(.business-primary, .business-secondary, .section-btn, .section-btn-secondary, .section-btn-danger, .support-new-ticket-btn, .design-new-ticket-btn, .terminal-refresh) {
  min-height: 42px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 500;
  padding: 11px 16px;
  box-shadow: none;
  text-decoration: none;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border: 1px solid transparent;
}

.lkfr-app :is(.business-primary, .section-btn, .support-new-ticket-btn, .design-new-ticket-btn) {
  background: var(--lkfr-accent);
  color: white;
}

.lkfr-app :is(.business-secondary, .section-btn-secondary, .terminal-refresh) {
  background: #f3f5f8;
  color: var(--lkfr-ink);
  border-color: var(--lkfr-border);
}

.lkfr-app .section-btn-danger {
  color: #b01f35;
  background: #fff0f2;
}

.lkfr-app :is(.section-input, .section-select, .section-textarea, .business-page input, .business-page select, .business-page textarea) {
  background: #fff;
  border: 1px solid #dce2eb;
  border-radius: 10px;
  font-size: 14px;
  min-height: 42px;
  padding: 10px 12px;
}

.lkfr-app .business-metrics {
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
}

.lkfr-app .business-metric {
  border-color: var(--lkfr-border);
  border-radius: var(--lkfr-radius);
  padding: 22px;
  gap: 10px;
}
.lkfr-app .business-metric > strong {
  font-size: clamp(24px, 2vw, 30px);
  font-weight: 600;
  letter-spacing: -0.03em;
}
.lkfr-app .business-metric > span {
  font-size: 12px;
  color: var(--lkfr-muted);
}
.lkfr-app .business-metric small {
  font-size: 12px;
  color: var(--lkfr-muted);
}

.lkfr-app .business-table th, .lkfr-app .business-table td {
  padding: 15px 12px;
  font-size: 13px;
}
.lkfr-app .business-table th {
  font-size: 11px;
  font-weight: 500;
  background: #fafbfc;
  color: var(--lkfr-muted);
}
.lkfr-app .business-table td {
  vertical-align: middle;
}

.lkfr-app .business-error, .lkfr-app .section-error {
  background: #fff1f3;
  border: 1px solid #f7d3da;
  color: #a9243a;
  padding: 16px;
  border-radius: 12px;
  font-size: 14px;
}

.lkfr-app .business-notice {
  background: #fff8e9;
  border: 1px solid #f2e4c8;
  color: #795c25;
  font-size: 14px;
}

.lkfr-app :is(.section-chip, .notif-filter-btn) {
  border-radius: 9px;
  font-size: 13px;
}

.lkfr-app .section-list {
  display: grid;
  gap: 14px;
}

.lkfr-app .section-item {
  border-radius: 12px;
  border-color: var(--lkfr-border);
  background: #fff;
}

.lkfr-app .section-grid {
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 14px;
}

.lkfr-app .section-stat {
  background: #f6f8fa;
  padding: 16px;
}

.lkfr-app .section-stat-value {
  font-size: 22px;
  letter-spacing: -0.025em;
  font-weight: 600;
}

.lkfr-app .section-form {
  gap: 20px;
}

.lkfr-app .section-form-columns {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
}

.lkfr-app .section-form-heading {
  font-size: 17px;
  margin: 0 0 16px;
}

.lkfr-app .section-inline > * {
  min-width: 0;
}

.lkfr-app .section-textarea {
  min-height: 100px;
}

.lkfr-app :is(.support-header-row, .design-header-row, .terminal-header) {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  margin: 0 0 20px;
}

.lkfr-app :is(.support-tickets-list, .design-tickets-list) {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.lkfr-app .support-ticket-card {
  margin: 0;
  padding: 20px;
  border-left-width: 3px;
}

.lkfr-app .ticket-status {
  font-size: 11px;
  font-weight: 500;
  padding: 5px 9px;
}

.lkfr-app .ticket-title {
  font-size: 16px;
}

.lkfr-app .ticket-card-dates {
  font-size: 12px;
}

.lkfr-app .terminal-header {
  justify-content: space-between;
}
.lkfr-app .terminal-header .terminal-title {
  margin: 0;
}

.lkfr-app .lkfr-schedule .timetable-block {
  max-width: none;
}

.lkfr-app .staff-mobile-list {
  display: none;
}

.lkfr-app .lkfr-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0 0 24px;
  padding: 5px;
  background: #eaf0f4;
  border-radius: 12px;
  width: fit-content;
}
.lkfr-app .lkfr-tabs a, .lkfr-app .lkfr-tabs button {
  text-decoration: none;
  color: var(--lkfr-muted);
  padding: 10px 16px;
  border: 0;
  border-radius: 9px;
  background: transparent;
  font: inherit;
  font-size: 13px;
}
.lkfr-app .lkfr-tabs a[aria-selected=true], .lkfr-app .lkfr-tabs a[aria-pressed=true], .lkfr-app .lkfr-tabs a.active, .lkfr-app .lkfr-tabs button[aria-selected=true], .lkfr-app .lkfr-tabs button[aria-pressed=true], .lkfr-app .lkfr-tabs button.active {
  color: var(--lkfr-ink);
  background: #fff;
  box-shadow: 0 1px 4px rgba(23, 32, 49, 0.0392156863);
}

.lkfr-app .lkfr-inline-links {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 14px 0 22px;
}

.lkfr-app .lkfr-draft-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  background: #f5f8fb;
  border: 1px solid var(--lkfr-border);
  border-radius: 12px;
  padding: 12px 16px;
  margin-bottom: 20px;
}

.lkfr-app .lkfr-document-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.lkfr-app .lkfr-preview-frame {
  width: 100%;
  min-height: 55vh;
  border: 1px solid var(--lkfr-border);
  border-radius: 12px;
}

.lkfr-app .lkfr-chart {
  width: 100%;
  height: 250px;
  margin: 12px 0;
}

.lkfr-app .business-chart-range {
  color: var(--lkfr-muted);
}

.lkfr-app--conversation .lkfr-content {
  padding-top: 22px;
  padding-bottom: 22px;
}

.lkfr-app .chats-page {
  max-width: none;
  width: 100%;
  margin: 0;
  --tg-accent: var(--lkfr-accent);
  --tg-bg: #f3f6f9;
  --tg-border: var(--lkfr-border);
}

.lkfr-app .chats-layout {
  height: calc(100dvh - 124px);
  min-height: 550px;
  border: 1px solid var(--lkfr-border);
  border-radius: 18px;
  overflow: hidden;
}

.lkfr-app .mobile-keyboard-mock {
  display: none;
}

.lkfr-app .assistant-hub-chat {
  border: 1px solid var(--lkfr-border);
  border-radius: 18px;
  overflow: hidden;
  background: white;
}
.lkfr-app .assistant-hub-chat .assistant-conversation {
  min-height: 580px;
  height: auto;
  max-height: none;
  color: var(--lkfr-ink);
}
.lkfr-app .assistant-hub-chat .assistant-messages {
  min-height: 240px;
  max-height: 65vh;
}

@media (min-width: 1100px) {
  .lkfr-sidebar {
    transform: none;
  }
  .lkfr-workspace {
    margin-left: var(--lkfr-sidebar-width);
  }
  .lkfr-nav-close, .lkfr-bottom-nav, .lkfr-app .header-menu {
    display: none;
  }
}
@media (max-width: 1099px) {
  .lkfr-content {
    padding: 24px 24px calc(88px + env(safe-area-inset-bottom));
  }
  .lkfr-app .app-header {
    display: grid;
    grid-template-columns: 44px minmax(0, 1fr) 44px;
    gap: 8px;
    padding: 10px 20px;
  }
  .lkfr-app .header-menu, .lkfr-app .header-bell {
    width: 44px;
    height: 44px;
    margin: 0;
  }
  .lkfr-sidebar {
    width: min(320px, 90vw);
    padding-top: 28px;
  }
  .lkfr-nav-link {
    min-height: 44px;
  }
  .lkfr-nav-close {
    width: 44px;
    height: 44px;
  }
}
@media (max-width: 650px) {
  .lkfr-app {
    --lkfr-header-height: 67px;
  }
  .lkfr-content {
    padding: 22px 16px calc(88px + env(safe-area-inset-bottom));
  }
  .lkfr-app .app-header {
    min-height: 66px;
    padding: 10px 12px;
  }
  .lkfr-app .header-address {
    font-size: 14px;
    max-width: 100%;
  }
  .lkfr-app .header-address-label {
    font-size: 10px;
  }
  .lkfr-app .business-back {
    margin-bottom: 14px;
  }
  .lkfr-app :is(.business-card, .section-card) {
    padding: 18px;
    margin-bottom: 16px;
  }
  .lkfr-app .business-subtitle {
    font-size: 14px;
  }
  .lkfr-app .business-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }
  .lkfr-app .business-metric {
    padding: 16px;
  }
  .lkfr-app .business-metric > strong {
    font-size: 23px;
    overflow-wrap: anywhere;
  }
  .lkfr-app .business-toolbar > label {
    min-width: 125px;
  }
  .lkfr-app :is(.support-tickets-list, .design-tickets-list, .section-form-columns, .lkfr-document-grid) {
    grid-template-columns: minmax(0, 1fr);
  }
  .lkfr-app .staff-desktop-table {
    display: none;
  }
  .lkfr-app .staff-mobile-list {
    display: grid;
    gap: 12px;
  }
  .lkfr-app .staff-mobile-card {
    border: 1px solid var(--lkfr-border);
    border-radius: 12px;
    padding: 16px;
    display: grid;
    gap: 14px;
    background: white;
  }
  .lkfr-app .staff-mobile-card > button {
    text-align: left;
    font-size: 16px;
    border: 0;
    background: transparent;
    color: var(--lkfr-ink);
    padding: 0;
    display: flex;
    justify-content: space-between;
    font-family: inherit;
    font-weight: 600;
  }
  .lkfr-app .staff-mobile-card dl {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
    margin: 0;
  }
  .lkfr-app .staff-mobile-card dt {
    font-size: 11px;
    color: var(--lkfr-muted);
  }
  .lkfr-app .staff-mobile-card dd {
    font-size: 15px;
    font-weight: 500;
    margin: 5px 0 0;
  }
  .lkfr-app .address-modal-overlay {
    padding: 0;
    align-items: flex-end;
  }
  .lkfr-app .address-modal-sheet {
    border-radius: 20px 20px 0 0;
    padding: 22px 18px calc(18px + env(safe-area-inset-bottom));
  }
  .lkfr-app--conversation .lkfr-content {
    padding: 0;
  }
  .lkfr-app .chats-layout {
    border-radius: 0;
    border: 0;
    height: calc(100dvh - 66px);
    min-height: 0;
  }
  .lkfr-app .assistant-hub-chat .assistant-conversation {
    min-height: 480px;
  }
  .lkfr-app .lkfr-dialog-actions {
    flex-direction: column;
  }
  .lkfr-app .lkfr-draft-banner {
    flex-wrap: wrap;
  }
}
@media (prefers-reduced-motion: reduce) {
  .lkfr-app *, .lkfr-app *::before, .lkfr-app *::after {
    animation-duration: 0.01ms !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}
.lkfr-dialog-wide {
  width: min(960px, 100vw - 32px);
}

.lkfr-dialog-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.lkfr-dialog-heading button {
  border: 0;
  background: transparent;
  font-size: 28px;
  cursor: pointer;
}

.document-preview-image {
  max-width: 100%;
  max-height: 65vh;
  object-fit: contain;
  display: block;
  margin: auto;
}

.document-name {
  overflow-wrap: anywhere;
  font-size: 19px;
}

.lkfr-form-fieldset {
  border: 0;
  padding: 0;
  margin: 0;
  min-width: 0;
}

.lkfr-budget-line {
  display: flex;
  align-items: end;
  gap: 12px;
  padding: 14px 0;
  border-bottom: 1px solid var(--lkfr-border);
  flex-wrap: wrap;
}

.lkfr-budget-line label {
  flex: 1 1;
  min-width: 100px;
  display: grid;
  gap: 6px;
  color: var(--lkfr-muted);
  font-size: 13px;
}

.lkfr-budget-line label:first-child {
  flex: 2 1;
  min-width: 180px;
}

.lkfr-budget-line input, .lkfr-budget-line select {
  width: 100%;
}

.staff-mobile-card dl {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin: 18px 0;
}

.staff-mobile-card dt {
  color: var(--lkfr-muted);
  font-size: 13px;
}

.staff-mobile-card dd {
  margin: 5px 0 0;
  font-weight: 600;
}

.lkfr-app .lkfr-tabs button[aria-pressed=true] {
  color: var(--lkfr-ink);
  background: white;
  box-shadow: 0 1px 4px rgba(23, 32, 49, 0.0392156863);
}

.lkfr-app .document-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.document-preview {
  width: 100%;
  height: 60vh;
  border: 1px solid var(--lkfr-border);
  border-radius: 12px;
}

.lkfr-app a.support-ticket-card {
  text-decoration: none;
  color: inherit;
  transition: box-shadow 0.15s;
}

.lkfr-app a.support-ticket-card:hover {
  box-shadow: 0 4px 18px rgba(23, 32, 49, 0.0705882353);
}

.lkfr-app a.support-ticket-card h2 {
  margin: 0;
}

@media (max-width: 700px) {
  .lkfr-app .document-grid {
    grid-template-columns: 1fr;
  }
  .lkfr-app .lkfr-draft-banner {
    align-items: flex-start;
    flex-direction: column;
  }
}
.lkfr-app .ticket-chat-page {
  width: 100%;
  max-width: none;
  height: calc(var(--ticket-chat-viewport-height, 100dvh) - 120px);
  min-height: 300px;
  border: 1px solid var(--lkfr-border);
  border-radius: 18px;
}

.lkfr-app .ticket-chat-header {
  border-radius: 0;
  box-shadow: none;
  border-bottom: 1px solid var(--lkfr-border);
}

body.ticket-native-document .lkfr-app .ticket-chat-page {
  top: 74px;
  left: var(--lkfr-sidebar-width);
  right: 0;
  width: calc(100% - var(--lkfr-sidebar-width));
  height: calc(var(--ticket-chat-viewport-height, 100dvh) - 74px);
  border-radius: 0;
}

@media (max-width: 1099px) {
  body.ticket-native-document .lkfr-app .ticket-chat-page {
    left: 0;
    width: 100%;
  }
}
@media (max-width: 650px) {
  .lkfr-app--conversation .lkfr-content {
    padding: 0;
  }
  .lkfr-app .ticket-chat-page {
    height: calc(var(--ticket-chat-viewport-height, 100dvh) - 66px);
    border-radius: 0;
    border: 0;
  }
  body.ticket-native-document .lkfr-app .ticket-chat-page {
    top: 66px;
    height: calc(var(--ticket-chat-viewport-height, 100dvh) - 66px);
  }
}
.lkfr-app .business-success {
  padding: 16px;
  border: 1px solid #bfdfce;
  border-radius: 12px;
  background: #edf9f1;
  color: #126842;
}

.lkfr-app .chats-page {
  min-height: 0;
  padding: 0;
}

.lkfr-app .chats-shell {
  height: calc(100dvh - 124px);
  min-height: 0;
  border: 1px solid var(--lkfr-border);
  border-radius: 18px;
  overflow: hidden;
}

.lkfr-app .chats-sidebar, .lkfr-app .chats-main {
  min-height: 0;
  max-height: 100%;
}

.lkfr-app .chats-menu-trigger {
  display: none;
}

.lkfr-app .notification-date-group {
  font-size: 14px;
  color: var(--lkfr-muted);
  margin: 18px 0 0;
}

@media (max-width: 650px) {
  .lkfr-app .chats-shell {
    height: calc(100dvh - 66px);
    border-radius: 0;
    border: 0;
  }
  .lkfr-app .chats-sidebar {
    height: 100%;
  }
  .lkfr-app .chats-main {
    height: 100%;
  }
}
.lkfr-app .chats-page {
  position: relative;
  inset: auto;
  height: auto;
  min-height: 0;
}

.lkfr-app .chats-page {
  --tg-font-main:"Cera Pro",Arial,sans-serif;
}

.lkfr-app .chats-page[data-chat-theme=light] {
  --tg-accent:var(--lkfr-accent);
  --tg-link:#bd213a;
  --tg-bubble-mine:#ffedef;
  --tg-sidebar:#fff;
  --tg-wallpaper-base:#f4f6f8;
}

.lkfr-app .assistant-hub-chat {
  --tg-accent:var(--lkfr-accent);
  --tg-link:#bd213a;
  --tg-text:var(--lkfr-ink);
}

.lkfr-app .assistant-hub-chat .assistant-conversation {
  font-family: inherit;
  min-height: 0;
}

.lkfr-app .assistant-hub-chat :is(.chats-primary, .chats-secondary, .chats-icon) {
  border: 1px solid var(--lkfr-border);
  color: var(--lkfr-ink);
  background: #f2f5f8;
  box-shadow: none;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 13px;
  cursor: pointer;
}

.lkfr-app .assistant-hub-chat .chats-primary {
  color: white;
  background: var(--lkfr-accent);
  border-color: var(--lkfr-accent);
}

.lkfr-app .assistant-hub-chat .assistant-composer textarea {
  font-size: 14px;
}

.lkfr-app .assistant-hub-chat .assistant-intro {
  font-size: 14px;
}

.lkfr-app .assistant-hub-chat .assistant-intro h3 {
  font-size: 18px;
}

.lkfr-app .assistant-hub-chat .assistant-conversation-head .chat-avatar {
  width: 38px;
  height: 38px;
  font-size: 13px;
  display: grid;
  place-items: center;
  border-radius: 12px;
  background: var(--lkfr-accent-soft);
  color: var(--lkfr-accent);
}

.lkfr-app .assistant-hub-chat .assistant-messages {
  max-height: 400px;
  min-height: 200px;
}

@media (max-width: 760px) {
  .lkfr-app .chats-page .chats-shell {
    height: calc(100dvh - 66px);
    min-height: 0;
  }
  .lkfr-app .chats-page .chats-main, .lkfr-app .chats-page .chats-sidebar {
    height: 100%;
  }
}
/* Phone controls stay readable without triggering Safari's input zoom. */
@media (max-width: 1099px) {
  .lkfr-app :is(input, select, textarea) {
    font-size: 16px;
  }
  .lkfr-app :is(.section-input, .section-select, .section-textarea, .business-page input, .business-page select, .business-page textarea, .assistant-composer textarea) {
    font-size: 16px;
  }
  .lkfr-app :is(.ticket-chat-input, .timetable-input-group input), .lkfr-app .chats-page .composer-input {
    font-size: 16px;
  }
  .lkfr-app .assistant-hub-chat .assistant-composer textarea, .lkfr-app .chats-page .chats-input {
    font-size: 16px;
  }
  .lkfr-app .chats-page .chats-search {
    width: 100%;
    min-width: 0;
  }
  .lkfr-app .chats-page :is(.chats-sidebar, .chats-main) {
    min-width: 0;
  }
  .lkfr-app .chats-page .chats-sidebar-head {
    display: flex;
    justify-content: space-between;
  }
  .lkfr-app .chats-page .chat-filter-chip {
    min-height: 44px;
  }
  .lkfr-app .chats-page :is(.chats-round-action, .chats-icon) {
    min-width: 44px;
    min-height: 44px;
  }
  .lkfr-app :is(input, select):not([type=checkbox]):not([type=radio]):not([type=file]) {
    min-height: 44px;
  }
  .lkfr-app .business-checklist label {
    min-height: 44px;
  }
  .lkfr-app :is(input[type=checkbox], input[type=radio]) {
    min-height: 0;
    width: 20px;
    height: 20px;
    flex: 0 0 20px;
    accent-color: var(--lkfr-accent);
  }
  .lkfr-app :is(.business-primary, .business-secondary, .section-btn, .section-btn-secondary, .section-btn-danger, .section-chip, .section-upload-remove, .notif-filter-btn, .records-filter-button, .lkfr-tabs button, .chats-icon, .chats-secondary, .chats-primary) {
    min-height: 44px;
  }
  .lkfr-app .assistant-scope :is(input, select) {
    font-size: 16px;
  }
  .lkfr-dialog {
    max-height: calc(100dvh - 32px);
    overflow-y: auto;
    padding: 20px;
  }
  .lkfr-dialog-heading {
    align-items: center;
  }
  .lkfr-dialog-heading button {
    width: 44px;
    height: 44px;
    flex: 0 0 auto;
  }
  .lkfr-dialog-actions button {
    min-height: 44px;
  }
  .lkfr-app .timetable :is(th, td).sticky-col {
    width: 110px;
    max-width: 110px;
    overflow-wrap: anywhere;
  }
  .lkfr-app .timetable td {
    height: 48px;
  }
  .lkfr-app[data-keyboard-open=true] .lkfr-bottom-nav {
    display: none;
  }
  .lkfr-app .chats-page .chats-shell, .lkfr-app .ticket-chat-page {
    min-height: 0;
    height: calc(var(--lkfr-viewport-height, 100dvh) - var(--lkfr-header-height) - 44px);
  }
  body.ticket-native-document .lkfr-app .ticket-chat-page {
    top: var(--lkfr-header-height);
    height: calc(var(--ticket-chat-viewport-height, var(--lkfr-viewport-height, 100dvh)) - var(--lkfr-header-height));
  }
}
@media (max-width: 650px) {
  .lkfr-app .terminal-marking-content {
    width: 100%;
    margin: 0;
    padding: 0;
  }
  .lkfr-app .terminal-marking-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .lkfr-app .terminal-marking-header button {
    width: 100%;
    min-height: 44px;
  }
  .lkfr-app .business-toolbar {
    align-items: stretch;
  }
  .lkfr-app .business-toolbar > label {
    flex: 1 1 160px;
    min-width: 0;
  }
  .lkfr-app .business-toolbar > :is(button, a) {
    flex: 1 1 auto;
  }
  .lkfr-app .section-inline {
    flex-direction: column;
    grid-template-columns: minmax(0, 1fr);
  }
  .lkfr-app .lkfr-inline-links a {
    display: flex;
    align-items: center;
    min-height: 44px;
    padding: 6px 10px;
    background: #fff;
    border: 1px solid var(--lkfr-border);
    border-radius: 10px;
    text-decoration: none;
  }
  .lkfr-app .timetable-input-group:not(.timetable-checkbox-row) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }
  .lkfr-app .timetable-input-group:not(.timetable-checkbox-row) > span {
    display: none;
  }
  .lkfr-app .timetable-input-group:not(.timetable-checkbox-row) label {
    display: grid;
    min-width: 0;
  }
  .lkfr-app .timetable-input-group input[type=time] {
    min-width: 0;
    width: 100%;
    margin: 0;
    padding: 8px;
  }
  .lkfr-app :is(.business-card, .section-card, .section-item) {
    min-width: 0;
    overflow-wrap: anywhere;
  }
  .lkfr-app .notif-container {
    max-width: none;
    padding: 0;
  }
  .lkfr-app [id] {
    scroll-margin-top: calc(var(--lkfr-header-height) + 12px);
  }
  .lkfr-app .mobile-card-table {
    display: block;
    width: 100%;
  }
  .lkfr-app .mobile-card-table thead {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip-path: inset(50%);
  }
  .lkfr-app .mobile-card-table tbody {
    display: grid;
    gap: 12px;
  }
  .lkfr-app .mobile-card-table tr {
    display: grid;
    gap: 8px;
    padding: 14px;
    border: 1px solid var(--lkfr-border);
    border-radius: 12px;
  }
  .lkfr-app .mobile-card-table td {
    display: grid;
    grid-template-columns: minmax(80px, 0.8fr) minmax(0, 1fr);
    align-items: center;
    gap: 10px;
    border: 0;
    padding: 0;
    font-size: 14px;
    overflow-wrap: anywhere;
  }
  .lkfr-app .mobile-card-table td::before {
    content: attr(data-label);
    color: var(--lkfr-muted);
    font-size: 12px;
    font-weight: 400;
  }
  .lkfr-app .mobile-card-table td > span {
    min-width: 0;
    text-align: right;
  }
  .lkfr-app .mobile-card-table td.mobile-table-actions {
    display: block;
    padding-top: 4px;
  }
  .lkfr-app .mobile-card-table td.mobile-table-actions::before {
    content: none;
  }
  .lkfr-app .mobile-card-table td.mobile-table-actions button {
    width: 100%;
  }
  .lkfr-app .ticket-chat-page {
    min-height: 0;
    height: calc(var(--ticket-chat-viewport-height, var(--lkfr-viewport-height, 100dvh)) - var(--lkfr-header-height));
  }
  body.ticket-native-document .lkfr-app .ticket-chat-page {
    top: var(--lkfr-header-height);
    height: calc(var(--ticket-chat-viewport-height, var(--lkfr-viewport-height, 100dvh)) - var(--lkfr-header-height));
  }
}
@media (max-width: 760px) {
  .lkfr-app--conversation .lkfr-content {
    padding: 0;
  }
  .lkfr-app .chats-page .chats-shell {
    grid-template-columns: minmax(0, 1fr);
    height: calc(var(--lkfr-viewport-height, 100dvh) - var(--lkfr-header-height));
  }
  .lkfr-app .chats-page .chats-sidebar {
    grid-template-columns: minmax(0, 1fr);
  }
  .lkfr-app .ticket-chat-page {
    height: calc(var(--ticket-chat-viewport-height, var(--lkfr-viewport-height, 100dvh)) - var(--lkfr-header-height));
  }
}
@media (max-width: 380px) {
  .lkfr-app .assistant-period {
    grid-template-columns: minmax(0, 1fr);
  }
}
.lkfr-messenger-icon {
  position: relative;
  display: flex;
}

.lkfr-app .lkfr-messenger-badge {
  position: absolute;
  top: -5px;
  right: -12px;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  border-radius: 10px;
  color: white;
  background: var(--lkfr-accent);
  font-size: 10px;
  line-height: 18px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/layout/design.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;EACA,2BAAA;AAAF;;AAEA;EAAO,0BAAA;EAA4B,0CAAA;EAA4C,sBAAA;AAI/E;;AAHA;EACE,0BAAA;EACA,kBAAA;EACA,sBAAA;EACA,0CAAA;AAMF;AALE;EAAyB,sBAAA;AAQ3B;AAPE;EAAkC,oBAAA;AAUpC;AATE;EAAY,wCAAA;AAYd;AAXE;EAAS,eAAA;AAcX;AAbE;EAAkB,eAAA;EAAiB,aAAA;AAiBrC;AAhBE;EAAiE,0BAAA;EAA4B,mBAAA;AAoB/F;AAnBE;EAAK,mCAAA;EAAqC,iBAAA;EAAmB,wBAAA;EAAyB,gBAAA;AAyBxF;AAxBE;EAAK,iBAAA;EAAmB,uBAAA;AA4B1B;AA3BE;EAAI,iBAAA;AA8BN;;AA5BA;EAAkB,YAAA;AAgClB;;AA/BA;EAAgB,wBAAA;EAA0B,YAAA;EAAc,aAAA;AAqCxD;;AApCA;EAAqB,gBAAA;EAAkB,MAAA;EAAQ,WAAA;EAAa,gBAAA;EAAkB,2CAAA;AA4C9E;;AA3CA;EAAwB,WAAA;EAAa,eAAA;EAAiB,SAAA;EAAW,gBAAA;EAAkB,kBAAA;EAAoB,gBAAA;EAAkB,gBAAA;EAAkB,uBAAA;AAsD3I;;AArDA;EAAyB,cAAA;EAAgB,WAAA;EAAa,YAAA;AA2DtD;;AA1DA;EAA+B,SAAA;EAAW,uBAAA;EAAyB,UAAA;EAAY,aAAA;EAAe,SAAA;EAAS,YAAA;EAAc,gBAAA;EAAkB,uBAAA;EAAyB,kBAAA;AAsEhK;;AArEA;EAAkC,aAAA;EAAe,sBAAA;EAAwB,mBAAA;EAAqB,YAAA;EAAc,eAAA;EAAiB,wBAAA;EAA0B,eAAA;EAAiB,gBAAA;EAAkB,uBAAA;AAiF1L;;AAhFA;EAAgC,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EAAyB,QAAA;EAAU,YAAA;EAAc,eAAA;AAyFrH;;AAxFA;EAA4B,cAAA;EAAgB,YAAA;EAAc,gBAAA;EAAkB,SAAA;EAAW,eAAA;EAAiB,gBAAA;EAAkB,sBAAA;EAAwB,uBAAA;EAAyB,mBAAA;EAAqB,gBAAA;AAqGhM;;AApGA;EAA0B,cAAA;EAAgB,cAAA;EAAgB,WAAA;EAAa,YAAA;EAAc,SAAA;EAAW,wBAAA;EAA0B,gCAAA;AA8G1H;;AA7GA;EAAmE,yBAAA;AAiHnE;;AAhHA;EAAyB,gBAAA;EAAkB,oCAAA;EAAsC,mBAAA;EAAqB,WAAA;EAAa,YAAA;AAwHnH;;AAvHA;EAA+B,SAAA;EAAW,WAAA;EAAa,gBAAA;AA6HvD;;AA5HA;EAA+B,iBAAA;AAgI/B;;AA/HA;EAAgB,eAAA;EAAiB,iBAAA;EAAmB,gCAAA;EAAkC,gBAAA;EAAkB,0CAAA;EAA4C,uBAAA;EAAyB,YAAA;EAAc,aAAA;EAAe,sBAAA;EAAwB,4BAAA;EAA8B,+BAAA;AA6IhQ;;AA5IA;EAAqB,eAAA;AAgJrB;;AA/IA;EAAc,aAAA;EAAe,sBAAA;EAAwB,uBAAA;EAAyB,oBAAA;EAAsB,qBAAA;EAAuB,cAAA;AAwJ3H;;AAvJA;EAAmB,yBAAA;EAA2B,eAAA;EAAiB,gBAAA;EAAkB,cAAA;EAAgB,wBAAA;AA+JjG;AA/J0H;EAAO,gBAAA;AAkKjI;;AAjKA;EAAsB,eAAA;EAAiB,wBAAA;EAA0B,eAAA;AAuKjE;;AAtKA;EAAmB,aAAA;EAAe,SAAA;EAAS,aAAA;AA4K3C;AA5K0D;EAAK,WAAA;EAAa,SAAA;EAAW,kBAAA;EAAoB,gBAAA;EAAkB,gBAAA;EAAkB,4BAAA;EAA8B,qBAAA;AAqL7K;;AApLA;EAAkB,gBAAA;AAwLlB;;AAvLA;EAAwB,cAAA;EAAgB,mBAAA;EAAqB,eAAA;EAAiB,gBAAA;EAAkB,sBAAA;EAAuB,yBAAA;EAA2B,cAAA;AAiMlJ;;AAhMA;EAAiB,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,gBAAA;EAAkB,iBAAA;EAAmB,aAAA;EAAe,mBAAA;EAAqB,eAAA;EAAiB,gBAAA;EAAkB,cAAA;EAAgB,qBAAA;EAAuB,yCAAA;AA+MnN;AA/M4P;EAAM,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,iBAAA;AAqN7S;AArNkU;EAAO,SAAA;AAwNzU;AAxNoV;EAAQ,wBAAA;AA2N5V;AA3NwX;EAAU,mBAAA;EAAqB,sBAAA;AA+NvZ;AA/Nib;EAAW,mCAAA;EAAqC,cAAA;AAmOje;;AAlOA;EAAoB,aAAA;EAAe,cAAA;EAAgB,mBAAA;EAAqB,SAAA;EAAW,qBAAA;EAAuB,sBAAA;EAAwB,mBAAA;EAAqB,wCAAA;EAA0C,gBAAA;AA8OjM;AA9OmN;EAAsB,YAAA;EAAc,SAAA;AAkPvP;AAlPkQ;EAAS,cAAA;EAAgB,eAAA;EAAiB,mBAAA;EAAqB,gBAAA;EAAkB,uBAAA;EAAyB,gBAAA;AA0P5W;AA1PgY;EAAQ,cAAA;EAAgB,wBAAA;EAA0B,eAAA;EAAiB,eAAA;AAgQnc;AAhQsd;EAAM,WAAA;EAAa,YAAA;EAAc,mBAAA;EAAqB,iBAAA;AAsQ5gB;;AArQA;EAAe,WAAA;EAAa,YAAA;EAAc,mBAAA;EAAqB,mBAAA;EAAqB,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,gBAAA;EAAkB,eAAA;EAAiB,cAAA;AAkR3L;;AAjRA;EAAkB,kBAAA;EAAoB,SAAA;EAAW,WAAA;EAAa,SAAA;EAAW,mBAAA;EAAqB,eAAA;EAAiB,WAAA;EAAa,YAAA;EAAc,mBAAA;AA6R1I;;AA5RA;EAAqB,eAAA;EAAiB,QAAA;EAAU,iCAAA;EAAuB,SAAA;EAAW,YAAA;AAoSlF;;AAnSA;EAAmB,eAAA;EAAiB,SAAA;EAAW,OAAA;EAAS,QAAA;EAAU,gDAAA;EAAkD,2CAAA;EAA6C,aAAA;EAAe,gDAAA;EAAkD,wCAAA;EAA0C,gBAAA;EAAkB,WAAA;AAiT9R;AAjT2S;EAAY,YAAA;EAAc,aAAA;EAAe,sBAAA;EAAwB,uBAAA;EAAyB,mBAAA;EAAqB,QAAA;EAAU,SAAA;EAAW,uBAAA;EAAyB,cAAA;EAAgB,eAAA;EAAiB,qBAAA;EAAuB,gBAAA;AA+ThgB;AA/TkhB;EAAM,WAAA;EAAa,YAAA;AAmUriB;AAnUqjB;EAAW,yBAAA;AAsUhkB;;AArUA;EAAkB,eAAA;EAAiB,iBAAA;EAAmB,YAAA;AA2UtD;;AA1UA;EAAgB,wBAAA;EAA0B,eAAA;EAAiB,gBAAA;EAAkB,sBAAA;EAAuB,yBAAA;AAkVpG;;AAjVA;EAAe,wBAAA;EAA0B,eAAA;EAAiB,iBAAA;AAuV1D;;AAtVA;EAAmB,kBAAA;EAAoB,kBAAA;EAAoB,gBAAA;EAAkB,YAAA;AA6V7E;AA7V2F;EAAI,wBAAA;EAA0B,mBAAA;AAiWzH;;AAhWA;EAAuB,eAAA;EAAiB,QAAA;EAAU,aAAA;EAAe,mBAAA;EAAqB,aAAA;EAAe,0CAAA;EAAuB,aAAA;AA0W5H;;AAzWA;EAAe,iBAAA;EAAmB,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EAAyB,sBAAA;EAAwB,0CAAA;EAA4C,sBAAA;AAmXnK;AAnX2L;EAAK,cAAA;EAAgB,eAAA;AAuXhN;AAvXmO;EAAQ,wBAAA;EAA0B,eAAA;EAAiB,gBAAA;AA4XtR;;AA3XA;EAAuB,aAAA;EAAe,eAAA;EAAiB,SAAA;EAAW,gBAAA;AAkYlE;AAlYoF;EAAS,aAAA;AAqY7F;;AApYA;EAAmC,mBAAA;EAAqB,aAAA;AAyYxD;;AAxYA;EAAiC,gBAAA;EAAkB,mBAAA;EAAqB,gBAAA;EAAkB,aAAA;AA+Y1F;;AA9YA;EAAiC,gBAAA;EAAkB,eAAA;AAmZnD;;AAlZA;EAAuB,aAAA;EAAe,sBAAA;EAAwB,QAAA;EAAU,eAAA;EAAiB,wBAAA;EAA0B,mBAAA;AA2ZnH;AA3ZwI;EAAQ,aAAA;EAAe,eAAA;EAAiB,kBAAA;EAAoB,oCAAA;EAAsC,mBAAA;AAka1O;;AAjaA;EAAmC,UAAA;AAqanC;AAra+C;EAAS,SAAA;EAAW,uBAAA;EAAyB,cAAA;EAAgB,aAAA;EAAe,WAAA;EAAa,gBAAA;EAAkB,aAAA;EAAe,8BAAA;EAAgC,mBAAA;EAAqB,SAAA;EAAW,kBAAA;EAAoB,mBAAA;AAmb7P;;AAlbA;EAAiC,mBAAA;EAAqB,eAAA;EAAiB,aAAA;AAwbvE;;AAtbA,6EAAA;AACA;EAAyL,WAAA;EAAa,eAAA;EAAiB,SAAA;EAAW,UAAA;EAAY,aAAA;EAAe,uBAAA;EAAyB,oBAAA;AAgctR;;AA/bA;EAAmH,gBAAA;AAmcnH;;AAlcA;EAAqD,gBAAA;AAscrD;;AArcA;EAA2B,oBAAA;EAAsB,mBAAA;EAAqB,eAAA;AA2ctE;;AA1cA;EAA0E,wBAAA;AA8c1E;;AA7cA;EAA+B,gBAAA;EAAkB,eAAA;EAAiB,gBAAA;AAmdlE;;AAldA;EAAsI,oCAAA;EAAsC,gBAAA;EAAkB,iCAAA;EAAmC,+BAAA;AAydjO;;AAxdA;EAA+C,aAAA;EAAe,mBAAA;AA6d9D;;AA5dA;EAAsD,eAAA;EAAiB,gBAAA;AAievE;;AAheA;EAAqD,SAAA;AAoerD;;AAneA;EAAuL,gBAAA;EAAkB,mBAAA;EAAqB,eAAA;EAAiB,gBAAA;EAAkB,kBAAA;EAAoB,gBAAA;EAAkB,qBAAA;EAAuB,oBAAA;EAAsB,uBAAA;EAAyB,mBAAA;EAAqB,QAAA;EAAU,6BAAA;AAkf5Y;;AAjfA;EAAkG,8BAAA;EAAgC,YAAA;AAsflI;;AArfA;EAAgF,mBAAA;EAAqB,sBAAA;EAAwB,gCAAA;AA2f7H;;AA1fA;EAAgC,cAAA;EAAgB,mBAAA;AA+fhD;;AA9fA;EAA0I,gBAAA;EAAkB,yBAAA;EAA2B,mBAAA;EAAqB,eAAA;EAAiB,gBAAA;EAAkB,kBAAA;AAugB/O;;AAtgBA;EAA8B,2DAAA;EAA6D,SAAA;AA2gB3F;;AA1gBA;EAA6B,gCAAA;EAAkC,iCAAA;EAAmC,aAAA;EAAe,SAAA;AAihBjH;AAjhB4H;EAAW,iCAAA;EAAmC,gBAAA;EAAkB,uBAAA;AAshB5L;AAthBsN;EAAS,eAAA;EAAiB,wBAAA;AA0hBhP;AA1hB4Q;EAAQ,eAAA;EAAiB,wBAAA;AA8hBrS;;AA7hB4B;EAAS,kBAAA;EAAoB,eAAA;AAkiBzD;AAliB4E;EAAK,eAAA;EAAiB,gBAAA;EAAkB,mBAAA;EAAqB,wBAAA;AAwiBzI;AAxiBqK;EAAK,sBAAA;AA2iB1K;;AA1iBA;EAAsD,mBAAA;EAAqB,yBAAA;EAA2B,cAAA;EAAgB,aAAA;EAAe,mBAAA;EAAqB,eAAA;AAmjB1J;;AAljBA;EAA6B,mBAAA;EAAqB,yBAAA;EAA2B,cAAA;EAAgB,eAAA;AAyjB7F;;AAxjBA;EAAkD,kBAAA;EAAoB,eAAA;AA6jBtE;;AA5jBA;EAA0B,aAAA;EAAe,SAAA;AAikBzC;;AAhkBA;EAA0B,mBAAA;EAAqB,gCAAA;EAAkC,gBAAA;AAskBjF;;AArkBA;EAA0B,2DAAA;EAA6D,SAAA;AA0kBvF;;AAzkBA;EAA0B,mBAAA;EAAqB,aAAA;AA8kB/C;;AA7kBA;EAAgC,eAAA;EAAiB,wBAAA;EAAyB,gBAAA;AAmlB1E;;AAllBA;EAA0B,SAAA;AAslB1B;;AArlBA;EAAkC,aAAA;EAAe,gDAAA;EAAkD,SAAA;AA2lBnG;;AA1lBA;EAAkC,eAAA;EAAiB,gBAAA;AA+lBnD;;AA9lBA;EAAgC,YAAA;AAkmBhC;;AAjmBA;EAA8B,iBAAA;AAqmB9B;;AApmBA;EAA2E,aAAA;EAAe,mBAAA;EAAqB,yBAAA;EAA2B,SAAA;EAAW,gBAAA;AA4mBrJ;;AA3mBA;EAA6D,aAAA;EAAe,gDAAA;EAAkD,SAAA;AAinB9H;;AAhnBA;EAAiC,SAAA;EAAW,aAAA;EAAe,sBAAA;AAsnB3D;;AArnBA;EAA2B,eAAA;EAAiB,gBAAA;EAAkB,gBAAA;AA2nB9D;;AA1nBA;EAA0B,eAAA;AA8nB1B;;AA7nBA;EAA+B,eAAA;AAioB/B;;AAhoBA;EAA6B,8BAAA;AAooB7B;AApoB6D;EAAkB,SAAA;AAuoB/E;;AAtoB2B;EAAmB,eAAA;AA0oB9C;;AAzoBA;EAA+B,aAAA;AA6oB/B;;AA5oBA;EAAuB,aAAA;EAAe,eAAA;EAAiB,QAAA;EAAU,gBAAA;EAAkB,YAAA;EAAc,mBAAA;EAAqB,mBAAA;EAAqB,kBAAA;AAupB3I;AAvpB+J;EAAY,qBAAA;EAAuB,wBAAA;EAA0B,kBAAA;EAAoB,SAAA;EAAW,kBAAA;EAAoB,uBAAA;EAAyB,aAAA;EAAe,eAAA;AAiqBvT;AAjqBwU;EAA4D,sBAAA;EAAwB,gBAAA;EAAkB,oDAAA;AAsqB9a;;AArqBA;EAA+B,aAAA;EAAe,eAAA;EAAiB,SAAA;EAAW,mBAAA;AA4qB1E;;AA3qBA;EAA+B,aAAA;EAAe,8BAAA;EAAgC,mBAAA;EAAqB,SAAA;EAAW,eAAA;EAAiB,mBAAA;EAAqB,oCAAA;EAAsC,mBAAA;EAAqB,kBAAA;EAAoB,mBAAA;AAwrBnO;;AAvrBA;EAAgC,aAAA;EAAe,gDAAA;EAAkD,SAAA;AA6rBjG;;AA5rBA;EAAgC,WAAA;EAAa,gBAAA;EAAkB,oCAAA;EAAsC,mBAAA;AAmsBrG;;AAlsBA;EAAwB,WAAA;EAAa,aAAA;EAAe,cAAA;AAwsBpD;;AAvsBA;EAAkC,wBAAA;AA2sBlC;;AA1sBA;EAAwC,iBAAA;EAAmB,oBAAA;AA+sB3D;;AA9sBA;EAAwB,eAAA;EAAiB,WAAA;EAAa,SAAA;EAAW,+BAAA;EAAiC,gBAAA;EAAkB,+BAAA;AAutBpH;;AAttBA;EAA0B,4BAAA;EAA8B,iBAAA;EAAmB,oCAAA;EAAsC,mBAAA;EAAqB,gBAAA;AA8tBtI;;AA7tBA;EAAkC,aAAA;AAiuBlC;;AAhuBA;EAAgC,oCAAA;EAAsC,mBAAA;EAAqB,gBAAA;EAAkB,iBAAA;AAuuB7G;AAvuBgI;EAA0B,iBAAA;EAAmB,YAAA;EAAc,gBAAA;EAAkB,sBAAA;AA6uB7M;AA7uBuO;EAAsB,iBAAA;EAAmB,gBAAA;AAivBhR;;AA/uBA;EACE;IAAgB,eAAA;EAmvBhB;EAlvBA;IAAkB,sCAAA;EAqvBlB;EApvBA;IAA4D,aAAA;EAuvB5D;AACF;AAtvBA;EACE;IAAgB,2DAAA;EAyvBhB;EAxvBA;IAAwB,aAAA;IAAe,+CAAA;IAAiD,QAAA;IAAU,kBAAA;EA8vBlG;EA7vBA;IAAiD,WAAA;IAAa,YAAA;IAAc,SAAA;EAkwB5E;EAjwBA;IAAgB,uBAAA;IAAyB,iBAAA;EAqwBzC;EApwBA;IAAiB,gBAAA;EAuwBjB;EAtwBA;IAAkB,WAAA;IAAa,YAAA;EA0wB/B;AACF;AAzwBA;EACE;IAAY,0BAAA;EA4wBZ;EA3wBA;IAAgB,2DAAA;EA8wBhB;EA7wBA;IAAwB,gBAAA;IAAkB,kBAAA;EAixB1C;EAhxBA;IAA4B,eAAA;IAAiB,eAAA;EAoxB7C;EAnxBA;IAAkC,eAAA;EAsxBlC;EArxBA;IAA2B,mBAAA;EAwxB3B;EAvxBA;IAA+C,aAAA;IAAe,mBAAA;EA2xB9D;EA1xBA;IAA+B,eAAA;EA6xB/B;EA5xBA;IAA8B,gDAAA;IAAkD,SAAA;EAgyBhF;EA/xBA;IAA6B,aAAA;EAkyB7B;EAlyB4C;IAAW,eAAA;IAAiB,uBAAA;EAsyBxE;EAryBA;IAAsC,gBAAA;EAwyBtC;EAvyBA;IAAyG,qCAAA;EA0yBzG;EAzyBA;IAAiC,aAAA;EA4yBjC;EA3yBA;IAA+B,aAAA;IAAe,SAAA;EA+yB9C;EA9yBA;IAA+B,oCAAA;IAAsC,mBAAA;IAAqB,aAAA;IAAe,aAAA;IAAe,SAAA;IAAW,iBAAA;EAszBnI;EAtzBsJ;IAAW,gBAAA;IAAkB,eAAA;IAAiB,SAAA;IAAW,uBAAA;IAAyB,sBAAA;IAAwB,UAAA;IAAY,aAAA;IAAe,8BAAA;IAAgC,oBAAA;IAAsB,gBAAA;EAk0BjV;EAl0BqW;IAAK,aAAA;IAAe,gDAAA;IAAkD,SAAA;IAAW,SAAA;EAw0Btb;EAx0Bmc;IAAK,eAAA;IAAiB,wBAAA;EA40Bzd;EA50Bqf;IAAK,eAAA;IAAiB,gBAAA;IAAkB,eAAA;EAi1B7hB;EAh1BA;IAAmC,UAAA;IAAY,qBAAA;EAo1B/C;EAn1BA;IAAiC,4BAAA;IAA8B,2DAAA;EAu1B/D;EAt1BA;IAAwC,UAAA;EAy1BxC;EAx1BA;IAA0B,gBAAA;IAAkB,SAAA;IAAW,2BAAA;IAA6B,aAAA;EA81BpF;EA71BA;IAAwD,iBAAA;EAg2BxD;EA/1BA;IAAiC,sBAAA;EAk2BjC;EAj2BA;IAA+B,eAAA;EAo2B/B;AACF;AAn2BA;EAA0C;IAAuD,qCAAA;IAAsC,sCAAA;IAAuC,gCAAA;EAy2B5K;AACF;AAz2BA;EAAoB,+BAAA;AA42BpB;;AA32BA;EAAuB,aAAA;EAAc,uBAAA;EAAwB,8BAAA;EAA+B,SAAA;AAk3B5F;;AAj3BA;EAA8B,SAAA;EAAU,uBAAA;EAAwB,eAAA;EAAgB,eAAA;AAw3BhF;;AAv3BA;EAA0B,eAAA;EAAgB,gBAAA;EAAiB,mBAAA;EAAoB,cAAA;EAAe,YAAA;AA+3B9F;;AA93BA;EAAiB,uBAAA;EAAwB,eAAA;AAm4BzC;;AAl4BA;EAAsB,SAAA;EAAU,UAAA;EAAW,SAAA;EAAU,YAAA;AAy4BrD;;AAx4BA;EAAoB,aAAA;EAAc,gBAAA;EAAiB,SAAA;EAAU,eAAA;EAAgB,2CAAA;EAA4C,eAAA;AAi5BzH;;AAh5BA;EAA0B,SAAA;EAAQ,gBAAA;EAAiB,aAAA;EAAc,QAAA;EAAS,wBAAA;EAAyB,eAAA;AAy5BnG;;AAx5BA;EAAsC,SAAA;EAAQ,gBAAA;AA65B9C;;AA55BA;EAAoD,WAAA;AAg6BpD;;AA/5BA;EAAwB,aAAA;EAAc,8BAAA;EAA+B,SAAA;EAAU,cAAA;AAs6B/E;;AAr6BA;EAAwB,wBAAA;EAAyB,eAAA;AA06BjD;;AAz6BA;EAAwB,eAAA;EAAgB,gBAAA;AA86BxC;;AA76BA;EAAmD,sBAAA;EAAuB,iBAAA;EAAkB,oDAAA;AAm7B5F;;AAl7BA;EAA2B,aAAA;EAAc,gDAAA;EAA+C,SAAA;AAw7BxF;;AAv7BA;EAAoB,WAAA;EAAY,YAAA;EAAa,oCAAA;EAAqC,mBAAA;AA87BlF;;AA77BA;EAAkC,qBAAA;EAAsB,cAAA;EAAe,4BAAA;AAm8BvE;;AAl8BA;EAAwC,qDAAA;AAs8BxC;;AAr8BA;EAAqC,SAAA;AAy8BrC;;AAx8BA;EAAyB;IAA2B,0BAAA;EA68BlD;EA78B+E;IAA+B,uBAAA;IAAwB,sBAAA;EAi9BtI;AACF;AAj9BA;EAA8B,WAAA;EAAY,eAAA;EAAgB,gEAAA;EAAiE,iBAAA;EAAkB,oCAAA;EAAqC,mBAAA;AAy9BlL;;AAx9BA;EAAgC,gBAAA;EAAiB,gBAAA;EAAiB,2CAAA;AA89BlE;;AA79BA;EAA0D,SAAA;EAAU,+BAAA;EAAgC,QAAA;EAAS,6CAAA;EAA8C,+DAAA;EAAgE,gBAAA;AAs+B3N;;AAr+BA;EAAyB;IAA0D,OAAA;IAAQ,WAAA;EA2+BzF;AACF;AA3+BA;EAAwB;IAAwC,UAAA;EA++B9D;EA/+B2E;IAA8B,+DAAA;IAAgE,gBAAA;IAAiB,SAAA;EAo/B1L;EAp/BsM;IAA0D,SAAA;IAAU,+DAAA;EAw/B1Q;AACF;AAx/BA;EAA8B,aAAA;EAAc,yBAAA;EAA0B,mBAAA;EAAoB,mBAAA;EAAoB,cAAA;AA+/B9G;;AA9/BA;EAAwB,aAAA;EAAc,UAAA;AAmgCtC;;AAlgCA;EAAyB,4BAAA;EAA6B,aAAA;EAAc,oCAAA;EAAqC,mBAAA;EAAoB,gBAAA;AA0gC7H;;AAzgCA;EAAkD,aAAA;EAAc,gBAAA;AA8gChE;;AA7gCA;EAAgC,aAAA;AAihChC;;AAhhCA;EAAqC,eAAA;EAAgB,wBAAA;EAAyB,gBAAA;AAshC9E;;AArhCA;EAAwB;IAAyB,2BAAA;IAA4B,gBAAA;IAAiB,SAAA;EA4hC5F;EA5hCwG;IAA2B,YAAA;EA+hCnI;EA/hCkJ;IAAwB,YAAA;EAkiC1K;AACF;AAliCA;EAAwB,kBAAA;EAAmB,WAAA;EAAY,YAAA;EAAa,aAAA;AAwiCpE;;AAviCA;EAAwB,0CAAA;AA2iCxB;;AA1iCA;EAAiD,8BAAA;EAAgC,iBAAA;EAAmB,wBAAA;EAA0B,iBAAA;EAAmB,2BAAA;AAkjCjJ;;AAjjCA;EAAgC,8BAAA;EAAgC,iBAAA;EAAmB,yBAAA;AAujCnF;;AAtjCA;EAAwD,oBAAA;EAAqB,aAAA;AA2jC7E;;AA1jCA;EAAiF,oCAAA;EAAqC,sBAAA;EAAuB,mBAAA;EAAoB,gBAAA;EAAiB,mBAAA;EAAoB,kBAAA;EAAmB,eAAA;EAAgB,eAAA;AAqkCzO;;AApkCA;EAA+C,YAAA;EAAa,8BAAA;EAA+B,gCAAA;AA0kC3F;;AAzkCA;EAA6D,eAAA;AA6kC7D;;AA5kCA;EAAiD,eAAA;AAglCjD;;AA/kCA;EAAoD,eAAA;AAmlCpD;;AAllCA;EAA0E,WAAA;EAAY,YAAA;EAAa,eAAA;EAAgB,aAAA;EAAc,mBAAA;EAAoB,mBAAA;EAAoB,mCAAA;EAAoC,yBAAA;AA6lC7M;;AA5lCA;EAAoD,iBAAA;EAAkB,iBAAA;AAimCtE;;AAhmCA;EAAwB;IAAqC,2BAAA;IAA4B,aAAA;EAsmCvF;EAtmCuG;IAA0E,YAAA;EAymCjL;AACF;AAxmCA,yEAAA;AACA;EACE;IAAyC,eAAA;EA2mCzC;EA1mCA;IAAwK,eAAA;EA6mCxK;EA5mCA;IAAyG,eAAA;EA+mCzG;EA9mCA;IAAiG,eAAA;EAinCjG;EAhnCA;IAAsC,WAAA;IAAa,YAAA;EAonCnD;EAnnCA;IAAyD,YAAA;EAsnCzD;EArnCA;IAA4C,aAAA;IAAe,8BAAA;EAynC3D;EAxnCA;IAA0C,gBAAA;EA2nC1C;EA1nCA;IAA8D,eAAA;IAAiB,gBAAA;EA8nC/E;EA7nCA;IAA6F,gBAAA;EAgoC7F;EA/nCA;IAAsC,gBAAA;EAkoCtC;EAjoCA;IAA6D,aAAA;IAAe,WAAA;IAAa,YAAA;IAAc,cAAA;IAAgB,gCAAA;EAwoCvH;EAvoCA;IAAuQ,gBAAA;EA0oCvQ;EAzoCA;IAAgD,eAAA;EA4oChD;EA3oCA;IAAe,+BAAA;IAAiC,gBAAA;IAAkB,aAAA;EAgpClE;EA/oCA;IAAuB,mBAAA;EAkpCvB;EAjpCA;IAA8B,WAAA;IAAa,YAAA;IAAc,cAAA;EAspCzD;EArpCA;IAA8B,gBAAA;EAwpC9B;EAvpCA;IAA8C,YAAA;IAAc,gBAAA;IAAkB,uBAAA;EA4pC9E;EA3pCA;IAA0B,YAAA;EA8pC1B;EA7pCA;IAAwD,aAAA;EAgqCxD;EA/pCA;IAAkE,aAAA;IAAe,oFAAA;EAmqCjF;EAlqCA;IAA0D,8BAAA;IAAgC,iHAAA;EAsqC1F;AACF;AArqCA;EACE;IAAsC,WAAA;IAAa,SAAA;IAAW,UAAA;EA0qC9D;EAzqCA;IAAqC,uBAAA;IAAyB,sBAAA;EA6qC9D;EA5qCA;IAA4C,WAAA;IAAa,gBAAA;EAgrCzD;EA/qCA;IAA8B,oBAAA;EAkrC9B;EAjrCA;IAAsC,eAAA;IAAiB,YAAA;EAqrCvD;EAprCA;IAA+C,cAAA;EAurC/C;EAtrCA;IAA4B,sBAAA;IAAwB,qCAAA;EA0rCpD;EAzrCA;IAAiC,aAAA;IAAe,mBAAA;IAAqB,gBAAA;IAAkB,iBAAA;IAAmB,gBAAA;IAAkB,oCAAA;IAAsC,mBAAA;IAAqB,qBAAA;EAmsCvL;EAlsCA;IAAgE,aAAA;IAAe,gDAAA;IAAkD,SAAA;EAusCjI;EAtsCA;IAAuE,aAAA;EAysCvE;EAxsCA;IAAsE,aAAA;IAAe,YAAA;EA4sCrF;EA3sCA;IAAsD,YAAA;IAAc,WAAA;IAAa,SAAA;IAAW,YAAA;EAitC5F;EAhtCA;IAA8D,YAAA;IAAc,uBAAA;EAotC5E;EAntCA;IAA6B,eAAA;IAAiB,UAAA;EAutC9C;EAttCA;IAAiB,yDAAA;EAytCjB;EAxtCA;IAA+B,cAAA;IAAgB,WAAA;EA4tC/C;EA3tCA;IAAqC,kBAAA;IAAoB,UAAA;IAAY,WAAA;IAAa,gBAAA;IAAkB,qBAAA;EAkuCpG;EAjuCA;IAAqC,aAAA;IAAe,SAAA;EAquCpD;EApuCA;IAAkC,aAAA;IAAe,QAAA;IAAU,aAAA;IAAe,oCAAA;IAAsC,mBAAA;EA2uChH;EA1uCA;IAAkC,aAAA;IAAe,yDAAA;IAA0D,mBAAA;IAAqB,SAAA;IAAW,SAAA;IAAW,UAAA;IAAY,eAAA;IAAiB,uBAAA;EAovCnL;EAnvCA;IAA0C,yBAAA;IAA2B,wBAAA;IAA0B,eAAA;IAAiB,gBAAA;EAyvChH;EAxvCA;IAAyC,YAAA;IAAc,iBAAA;EA4vCvD;EA3vCA;IAAuD,cAAA;IAAgB,gBAAA;EA+vCvE;EA9vCA;IAA+D,aAAA;EAiwC/D;EAhwCA;IAA8D,WAAA;EAmwC9D;EAlwCA;IAA8B,aAAA;IAAe,iHAAA;EAswC7C;EArwCA;IAA0D,8BAAA;IAAgC,iHAAA;EAywC1F;AACF;AAxwCA;EACE;IAAwC,UAAA;EA2wCxC;EA1wCA;IAAqC,qCAAA;IAAuC,6EAAA;EA8wC5E;EA7wCA;IAAuC,qCAAA;EAgxCvC;EA/wCA;IAA8B,iHAAA;EAkxC9B;AACF;AAjxCA;EAA4B;IAA8B,qCAAA;EAqxCxD;AACF;AApxCA;EAAuB,kBAAA;EAAoB,aAAA;AAwxC3C;;AAvxCA;EAAkC,kBAAA;EAAoB,SAAA;EAAW,YAAA;EAAc,eAAA;EAAiB,YAAA;EAAc,cAAA;EAAgB,mBAAA;EAAqB,YAAA;EAAc,8BAAA;EAAgC,eAAA;EAAiB,iBAAA;EAAmB,kBAAA;AAsyCrO","sourcesContent":["\n:root {\n  --lkfr-bg: #f5f6f8;\n  --lkfr-surface: #fff;\n  --lkfr-ink: #232737;\n  --lkfr-muted: #657085;\n  --lkfr-border: #e4e8ee;\n  --lkfr-accent: #e72f44;\n  --lkfr-accent-soft: #fff0f2;\n  --lkfr-success: #14764d;\n  --lkfr-radius: 18px;\n  --lkfr-sidebar-width: 264px;\n}\nbody { background: var(--lkfr-bg); font-family: \"Cera Pro\", Arial, sans-serif; color: var(--lkfr-ink); }\n.lkfr-app {\n  --lkfr-header-height: 75px;\n  min-height: 100dvh;\n  color: var(--lkfr-ink);\n  font-family: \"Cera Pro\", Arial, sans-serif;\n  *, *::before, *::after { box-sizing: border-box; }\n  button, input, select, textarea { font-family: inherit; }\n  button, a { -webkit-tap-highlight-color: transparent; }\n  button { cursor: pointer; }\n  button:disabled { cursor: default; opacity: .55; }\n  :is(button, a, input, select, textarea, summary):focus-visible { outline: 3px solid #5365cc; outline-offset: 3px; }\n  h1 { font-size: clamp(26px, 2.6vw, 34px); line-height: 1.15; letter-spacing: -.035em; font-weight: 700; }\n  h2 { line-height: 1.25; letter-spacing: -.02em; }\n  p { line-height: 1.55; }\n}\n.lkfr-workspace { min-width: 0; }\n.lkfr-content { width: min(100%, 1328px); margin: auto; padding: 32px; }\n.lkfr-shell-header { position: sticky; top: 0; z-index: 90; background: #fff; border-bottom: 1px solid var(--lkfr-border); }\n.lkfr-app .app-header { width: 100%; max-width: none; margin: 0; min-height: 74px; padding: 12px 32px; border-radius: 0; box-shadow: none; background: transparent; }\n.lkfr-app .header-menu { flex: 0 0 auto; width: 40px; height: 44px; }\n.lkfr-app .header-logo-group { border: 0; background: transparent; padding: 0; font: inherit; flex: 1; min-width: 0; min-height: 44px; justify-content: center; text-align: center; }\n.lkfr-app .header-address-label { display: flex; flex-direction: column; align-items: center; min-width: 0; max-width: 100%; color: var(--lkfr-muted); font-size: 11px; line-height: 1.5; letter-spacing: .015em; }\n.lkfr-app .header-address-row { display: flex; align-items: center; justify-content: center; gap: 6px; min-width: 0; max-width: 100%; }\n.lkfr-app .header-address { display: block; min-width: 0; max-width: 680px; margin: 0; font-size: 15px; font-weight: 500; color: var(--lkfr-ink); text-overflow: ellipsis; white-space: nowrap; overflow: hidden; }\n.lkfr-app .header-arrow { display: block; flex: 0 0 16px; width: 16px; height: 16px; margin: 0; color: var(--lkfr-muted); transition: transform .18s ease; }\n.lkfr-app .header-logo-group[aria-expanded=\"true\"] .header-arrow { transform: rotate(180deg); }\n.lkfr-app .header-bell { box-shadow: none; border: 1px solid var(--lkfr-border); border-radius: 12px; width: 42px; height: 42px; }\n.lkfr-app .header-bell-badge { top: -5px; right: -5px; box-shadow: none; }\n.lkfr-app .header-load-error { margin: 12px 24px; }\n.lkfr-sidebar { position: fixed; inset: 0 auto 0 0; width: var(--lkfr-sidebar-width); background: #fff; border-right: 1px solid var(--lkfr-border); padding: 24px 16px 16px; z-index: 110; display: flex; flex-direction: column; transform: translateX(-100%); transition: transform .2s ease; }\n.lkfr-sidebar.open { transform: none; }\n.lkfr-brand { display: flex; flex-direction: column; align-items: flex-start; padding: 0 14px 22px; text-decoration: none; flex: 0 0 auto; }\n.lkfr-brand-mark { color: var(--lkfr-accent); font-size: 28px; font-weight: 800; line-height: 1; letter-spacing: -.055em; span { margin-left: 5px; } }\n.lkfr-brand-caption { font-size: 11px; color: var(--lkfr-muted); margin-top: 7px; }\n.lkfr-navigation { min-height: 0; flex: 1; display: flex; ul { width: 100%; margin: 0; padding: 0 3px 0 0; list-style: none; overflow-y: auto; overscroll-behavior: contain; scrollbar-width: thin; } }\n.lkfr-nav-group { margin: 0 0 22px; }\n.lkfr-nav-group-label { display: block; padding: 0 14px 8px; font-size: 10px; font-weight: 500; letter-spacing: .07em; text-transform: uppercase; color: #7c8595; }\n.lkfr-nav-link { display: flex; align-items: center; gap: 11px; min-height: 41px; padding: 8px 12px; margin: 3px 0; border-radius: 10px; font-size: 13px; font-weight: 500; color: #505b6d; text-decoration: none; transition: background .15s, color .15s; svg { width: 19px; height: 19px; flex: 0 0 auto; stroke-width: 1.7; } span { flex: 1; } small { color: var(--lkfr-muted); } &:hover { background: #f4f6f8; color: var(--lkfr-ink); } &.active { background: var(--lkfr-accent-soft); color: #bf1e32; } }\n.lkfr-nav-profile { display: flex; flex: 0 0 auto; align-items: center; gap: 10px; text-decoration: none; color: var(--lkfr-ink); padding: 14px 8px 0; border-top: 1px solid var(--lkfr-border); margin-top: 12px; > span:nth-child(2) { min-width: 0; flex: 1; } strong { display: block; font-size: 12px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-weight: 500; } small { display: block; color: var(--lkfr-muted); font-size: 11px; margin-top: 4px; } img { width: 36px; height: 36px; border-radius: 12px; object-fit: cover; } }\n.lkfr-avatar { width: 36px; height: 36px; border-radius: 12px; background: #f1f3f7; display: inline-flex; align-items: center; justify-content: center; font-weight: 600; font-size: 13px; flex: 0 0 auto; }\n.lkfr-nav-close { position: absolute; top: 15px; right: 13px; border: 0; background: #f3f5f7; font-size: 24px; width: 36px; height: 36px; border-radius: 10px; }\n.lkfr-nav-backdrop { position: fixed; inset: 0; background: #18223466; border: 0; z-index: 105; }\n.lkfr-bottom-nav { position: fixed; bottom: 0; left: 0; right: 0; height: calc(65px + env(safe-area-inset-bottom)); padding-bottom: env(safe-area-inset-bottom); display: grid; grid-template-columns: repeat(5, minmax(0, 1fr)); border-top: 1px solid var(--lkfr-border); background: #fff; z-index: 95; a, button { min-width: 0; display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 5px; border: 0; background: transparent; color: #717b8c; font-size: 10px; text-decoration: none; font-weight: 500; svg { width: 21px; height: 21px; } &.active { color: var(--lkfr-accent); } } }\n.lkfr-more-icon { font-size: 29px; line-height: 21px; height: 21px; }\n.lkfr-eyebrow { color: var(--lkfr-muted); font-size: 11px; font-weight: 600; letter-spacing: .08em; text-transform: uppercase; }\n.lkfr-helper { color: var(--lkfr-muted); font-size: 13px; line-height: 1.55; }\n.lkfr-empty-page { text-align: center; padding: 80px 16px; max-width: 620px; margin: auto; p { color: var(--lkfr-muted); margin: 20px 0 28px; } }\n.lkfr-dialog-overlay { position: fixed; inset: 0; display: grid; place-items: center; padding: 20px; background: #17203170; z-index: 5000; }\n.lkfr-dialog { background: white; padding: 28px; border-radius: 20px; width: min(100%, 470px); color: var(--lkfr-ink); font-family: \"Cera Pro\", Arial, sans-serif; box-sizing: border-box; h2 { margin: 12px 0; font-size: 23px; } p, li { color: var(--lkfr-muted); font-size: 14px; line-height: 1.6; } }\n.lkfr-dialog-actions { display: flex; flex-wrap: wrap; gap: 10px; margin-top: 24px; button { font: inherit; } }\n.lkfr-app .address-modal-overlay { align-items: center; padding: 24px; }\n.lkfr-app .address-modal-sheet { max-width: 520px; border-radius: 20px; box-shadow: none; padding: 24px; }\n.lkfr-app .address-modal-title { text-align: left; font-size: 23px; }\n.lkfr-company-search { display: flex; flex-direction: column; gap: 8px; font-size: 12px; color: var(--lkfr-muted); margin-bottom: 14px; input { font: inherit; font-size: 14px; padding: 11px 12px; border: 1px solid var(--lkfr-border); border-radius: 10px; } }\n.lkfr-app .address-modal-list li { padding: 0; button { border: 0; background: transparent; color: inherit; font: inherit; width: 100%; text-align: left; display: flex; justify-content: space-between; align-items: center; gap: 12px; padding: 13px 12px; border-radius: 10px; } }\n.lkfr-app .address-modal-close { border-radius: 10px; font-size: 14px; padding: 12px; }\n\n/* The same page width, form controls and surfaces across both generations. */\n.lkfr-app :is(.business-page, .section-page, .support-tickets-page, .design-tickets-page, .terminal-page, .profile-page, .notif-page, .budget-page, .ops-page, .terminal-marking-page) { width: 100%; max-width: none; margin: 0; padding: 0; min-height: 0; background: transparent; font-family: inherit; }\n.lkfr-app :is(.section-title, .support-tickets-title, .design-tickets-title, .terminal-title, .notif-title-page) { margin: 0 0 24px; }\n.lkfr-app :is(.business-page > h1, .ops-page > h1) { margin: 0 0 10px; }\n.lkfr-app .business-back { display: inline-flex; margin-bottom: 20px; font-size: 12px; }\n.lkfr-app :is(.business-subtitle, .section-helper, .section-stat-label) { color: var(--lkfr-muted); }\n.lkfr-app .business-subtitle { max-width: 780px; font-size: 15px; margin: 0 0 26px; }\n.lkfr-app :is(.business-card, .section-card, .terminal-card, .support-ticket-card, .design-ticket-card, .profile-card, .notif-card) { border: 1px solid var(--lkfr-border); box-shadow: none; border-radius: var(--lkfr-radius); background: var(--lkfr-surface); }\n.lkfr-app :is(.business-card, .section-card) { padding: 24px; margin-bottom: 20px; }\n.lkfr-app :is(.business-card h2, .section-subtitle) { font-size: 19px; font-weight: 600; }\n.lkfr-app :is(.business-toolbar, .section-toolbar) { gap: 12px; }\n.lkfr-app :is(.business-primary, .business-secondary, .section-btn, .section-btn-secondary, .section-btn-danger, .support-new-ticket-btn, .design-new-ticket-btn, .terminal-refresh) { min-height: 42px; border-radius: 10px; font-size: 13px; font-weight: 500; padding: 11px 16px; box-shadow: none; text-decoration: none; display: inline-flex; justify-content: center; align-items: center; gap: 8px; border: 1px solid transparent; }\n.lkfr-app :is(.business-primary, .section-btn, .support-new-ticket-btn, .design-new-ticket-btn) { background: var(--lkfr-accent); color: white; }\n.lkfr-app :is(.business-secondary, .section-btn-secondary, .terminal-refresh) { background: #f3f5f8; color: var(--lkfr-ink); border-color: var(--lkfr-border); }\n.lkfr-app .section-btn-danger { color: #b01f35; background: #fff0f2; }\n.lkfr-app :is(.section-input, .section-select, .section-textarea, .business-page input, .business-page select, .business-page textarea) { background: #fff; border: 1px solid #dce2eb; border-radius: 10px; font-size: 14px; min-height: 42px; padding: 10px 12px; }\n.lkfr-app .business-metrics { grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 16px; }\n.lkfr-app .business-metric { border-color: var(--lkfr-border); border-radius: var(--lkfr-radius); padding: 22px; gap: 10px; > strong { font-size: clamp(24px, 2vw, 30px); font-weight: 600; letter-spacing: -.03em; } > span { font-size: 12px; color: var(--lkfr-muted); } small { font-size: 12px; color: var(--lkfr-muted); } }\n.lkfr-app .business-table { th, td { padding: 15px 12px; font-size: 13px; } th { font-size: 11px; font-weight: 500; background: #fafbfc; color: var(--lkfr-muted); } td { vertical-align: middle; } }\n.lkfr-app .business-error, .lkfr-app .section-error { background: #fff1f3; border: 1px solid #f7d3da; color: #a9243a; padding: 16px; border-radius: 12px; font-size: 14px; }\n.lkfr-app .business-notice { background: #fff8e9; border: 1px solid #f2e4c8; color: #795c25; font-size: 14px; }\n.lkfr-app :is(.section-chip, .notif-filter-btn) { border-radius: 9px; font-size: 13px; }\n.lkfr-app .section-list { display: grid; gap: 14px; }\n.lkfr-app .section-item { border-radius: 12px; border-color: var(--lkfr-border); background: #fff; }\n.lkfr-app .section-grid { grid-template-columns: repeat(auto-fit, minmax(160px, 1fr)); gap: 14px; }\n.lkfr-app .section-stat { background: #f6f8fa; padding: 16px; }\n.lkfr-app .section-stat-value { font-size: 22px; letter-spacing: -.025em; font-weight: 600; }\n.lkfr-app .section-form { gap: 20px; }\n.lkfr-app .section-form-columns { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 24px; }\n.lkfr-app .section-form-heading { font-size: 17px; margin: 0 0 16px; }\n.lkfr-app .section-inline > * { min-width: 0; }\n.lkfr-app .section-textarea { min-height: 100px; }\n.lkfr-app :is(.support-header-row, .design-header-row, .terminal-header) { display: flex; align-items: center; justify-content: flex-end; gap: 16px; margin: 0 0 20px; }\n.lkfr-app :is(.support-tickets-list, .design-tickets-list) { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px; }\n.lkfr-app .support-ticket-card { margin: 0; padding: 20px; border-left-width: 3px; }\n.lkfr-app .ticket-status { font-size: 11px; font-weight: 500; padding: 5px 9px; }\n.lkfr-app .ticket-title { font-size: 16px; }\n.lkfr-app .ticket-card-dates { font-size: 12px; }\n.lkfr-app .terminal-header { justify-content: space-between; .terminal-title { margin: 0; } }\n.lkfr-app .lkfr-schedule { .timetable-block { max-width: none; } }\n.lkfr-app .staff-mobile-list { display: none; }\n.lkfr-app .lkfr-tabs { display: flex; flex-wrap: wrap; gap: 8px; margin: 0 0 24px; padding: 5px; background: #eaf0f4; border-radius: 12px; width: fit-content; a, button { text-decoration: none; color: var(--lkfr-muted); padding: 10px 16px; border: 0; border-radius: 9px; background: transparent; font: inherit; font-size: 13px; &[aria-selected=\"true\"], &[aria-pressed=\"true\"], &.active { color: var(--lkfr-ink); background: #fff; box-shadow: 0 1px 4px #1720310a; } } }\n.lkfr-app .lkfr-inline-links { display: flex; flex-wrap: wrap; gap: 10px; margin: 14px 0 22px; }\n.lkfr-app .lkfr-draft-banner { display: flex; justify-content: space-between; align-items: center; gap: 12px; font-size: 13px; background: #f5f8fb; border: 1px solid var(--lkfr-border); border-radius: 12px; padding: 12px 16px; margin-bottom: 20px; }\n.lkfr-app .lkfr-document-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px; }\n.lkfr-app .lkfr-preview-frame { width: 100%; min-height: 55vh; border: 1px solid var(--lkfr-border); border-radius: 12px; }\n.lkfr-app .lkfr-chart { width: 100%; height: 250px; margin: 12px 0; }\n.lkfr-app .business-chart-range { color: var(--lkfr-muted); }\n.lkfr-app--conversation .lkfr-content { padding-top: 22px; padding-bottom: 22px; }\n.lkfr-app .chats-page { max-width: none; width: 100%; margin: 0; --tg-accent: var(--lkfr-accent); --tg-bg: #f3f6f9; --tg-border: var(--lkfr-border); }\n.lkfr-app .chats-layout { height: calc(100dvh - 124px); min-height: 550px; border: 1px solid var(--lkfr-border); border-radius: 18px; overflow: hidden; }\n.lkfr-app .mobile-keyboard-mock { display: none; }\n.lkfr-app .assistant-hub-chat { border: 1px solid var(--lkfr-border); border-radius: 18px; overflow: hidden; background: white; .assistant-conversation { min-height: 580px; height: auto; max-height: none; color: var(--lkfr-ink); } .assistant-messages { min-height: 240px; max-height: 65vh; } }\n\n@media (min-width: 1100px) {\n  .lkfr-sidebar { transform: none; }\n  .lkfr-workspace { margin-left: var(--lkfr-sidebar-width); }\n  .lkfr-nav-close, .lkfr-bottom-nav, .lkfr-app .header-menu { display: none; }\n}\n@media (max-width: 1099px) {\n  .lkfr-content { padding: 24px 24px calc(88px + env(safe-area-inset-bottom)); }\n  .lkfr-app .app-header { display: grid; grid-template-columns: 44px minmax(0, 1fr) 44px; gap: 8px; padding: 10px 20px; }\n  .lkfr-app .header-menu, .lkfr-app .header-bell { width: 44px; height: 44px; margin: 0; }\n  .lkfr-sidebar { width: min(320px, 90vw); padding-top: 28px; }\n  .lkfr-nav-link { min-height: 44px; }\n  .lkfr-nav-close { width: 44px; height: 44px; }\n}\n@media (max-width: 650px) {\n  .lkfr-app { --lkfr-header-height: 67px; }\n  .lkfr-content { padding: 22px 16px calc(88px + env(safe-area-inset-bottom)); }\n  .lkfr-app .app-header { min-height: 66px; padding: 10px 12px; }\n  .lkfr-app .header-address { font-size: 14px; max-width: 100%; }\n  .lkfr-app .header-address-label { font-size: 10px; }\n  .lkfr-app .business-back { margin-bottom: 14px; }\n  .lkfr-app :is(.business-card, .section-card) { padding: 18px; margin-bottom: 16px; }\n  .lkfr-app .business-subtitle { font-size: 14px; }\n  .lkfr-app .business-metrics { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }\n  .lkfr-app .business-metric { padding: 16px; > strong { font-size: 23px; overflow-wrap: anywhere; } }\n  .lkfr-app .business-toolbar > label { min-width: 125px; }\n  .lkfr-app :is(.support-tickets-list, .design-tickets-list, .section-form-columns, .lkfr-document-grid) { grid-template-columns: minmax(0, 1fr); }\n  .lkfr-app .staff-desktop-table { display: none; }\n  .lkfr-app .staff-mobile-list { display: grid; gap: 12px; }\n  .lkfr-app .staff-mobile-card { border: 1px solid var(--lkfr-border); border-radius: 12px; padding: 16px; display: grid; gap: 14px; background: white; > button { text-align: left; font-size: 16px; border: 0; background: transparent; color: var(--lkfr-ink); padding: 0; display: flex; justify-content: space-between; font-family: inherit; font-weight: 600; } dl { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 14px; margin: 0; } dt { font-size: 11px; color: var(--lkfr-muted); } dd { font-size: 15px; font-weight: 500; margin: 5px 0 0; } }\n  .lkfr-app .address-modal-overlay { padding: 0; align-items: flex-end; }\n  .lkfr-app .address-modal-sheet { border-radius: 20px 20px 0 0; padding: 22px 18px calc(18px + env(safe-area-inset-bottom)); }\n  .lkfr-app--conversation .lkfr-content { padding: 0; }\n  .lkfr-app .chats-layout { border-radius: 0; border: 0; height: calc(100dvh - 66px); min-height: 0; }\n  .lkfr-app .assistant-hub-chat .assistant-conversation { min-height: 480px; }\n  .lkfr-app .lkfr-dialog-actions { flex-direction: column; }\n  .lkfr-app .lkfr-draft-banner { flex-wrap: wrap; }\n}\n@media (prefers-reduced-motion: reduce) { .lkfr-app *, .lkfr-app *::before, .lkfr-app *::after { animation-duration: .01ms !important; transition-duration: .01ms !important; scroll-behavior: auto !important; } }\n.lkfr-dialog-wide { width: min(960px, calc(100vw - 32px)); }\n.lkfr-dialog-heading { display:flex; align-items:flex-start; justify-content:space-between; gap:16px; }\n.lkfr-dialog-heading button { border:0; background:transparent; font-size:28px; cursor:pointer; }\n.document-preview-image { max-width:100%; max-height:65vh; object-fit:contain; display:block; margin:auto; }\n.document-name { overflow-wrap:anywhere; font-size:19px; }\n.lkfr-form-fieldset { border:0; padding:0; margin:0; min-width:0; }\n.lkfr-budget-line { display:flex; align-items:end; gap:12px; padding:14px 0; border-bottom:1px solid var(--lkfr-border); flex-wrap:wrap; }\n.lkfr-budget-line label { flex:1; min-width:100px; display:grid; gap:6px; color:var(--lkfr-muted); font-size:13px; }\n.lkfr-budget-line label:first-child { flex:2; min-width:180px; }\n.lkfr-budget-line input, .lkfr-budget-line select { width:100%; }\n.staff-mobile-card dl { display:grid; grid-template-columns:1fr 1fr; gap:14px; margin:18px 0; }\n.staff-mobile-card dt { color:var(--lkfr-muted); font-size:13px; }\n.staff-mobile-card dd { margin:5px 0 0; font-weight:600; }\n.lkfr-app .lkfr-tabs button[aria-pressed=\"true\"] { color:var(--lkfr-ink); background:white; box-shadow:0 1px 4px #1720310a; }\n.lkfr-app .document-grid { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:16px; }\n.document-preview { width:100%; height:60vh; border:1px solid var(--lkfr-border); border-radius:12px; }\n.lkfr-app a.support-ticket-card { text-decoration:none; color:inherit; transition:box-shadow .15s; }\n.lkfr-app a.support-ticket-card:hover { box-shadow:0 4px 18px #17203112; }\n.lkfr-app a.support-ticket-card h2 { margin:0; }\n@media(max-width:700px){ .lkfr-app .document-grid { grid-template-columns:1fr; } .lkfr-app .lkfr-draft-banner { align-items:flex-start; flex-direction:column; } }\n.lkfr-app .ticket-chat-page { width:100%; max-width:none; height:calc(var(--ticket-chat-viewport-height, 100dvh) - 120px); min-height:300px; border:1px solid var(--lkfr-border); border-radius:18px; }\n.lkfr-app .ticket-chat-header { border-radius:0; box-shadow:none; border-bottom:1px solid var(--lkfr-border); }\nbody.ticket-native-document .lkfr-app .ticket-chat-page { top:74px; left:var(--lkfr-sidebar-width); right:0; width:calc(100% - var(--lkfr-sidebar-width)); height:calc(var(--ticket-chat-viewport-height, 100dvh) - 74px); border-radius:0; }\n@media(max-width:1099px){body.ticket-native-document .lkfr-app .ticket-chat-page { left:0; width:100%; }}\n@media(max-width:650px){.lkfr-app--conversation .lkfr-content { padding:0; } .lkfr-app .ticket-chat-page { height:calc(var(--ticket-chat-viewport-height, 100dvh) - 66px); border-radius:0; border:0; } body.ticket-native-document .lkfr-app .ticket-chat-page { top:66px; height:calc(var(--ticket-chat-viewport-height, 100dvh) - 66px); }}\n.lkfr-app .business-success { padding:16px; border:1px solid #bfdfce; border-radius:12px; background:#edf9f1; color:#126842; }\n.lkfr-app .chats-page { min-height:0; padding:0; }\n.lkfr-app .chats-shell { height:calc(100dvh - 124px); min-height:0; border:1px solid var(--lkfr-border); border-radius:18px; overflow:hidden; }\n.lkfr-app .chats-sidebar, .lkfr-app .chats-main { min-height:0; max-height:100%; }\n.lkfr-app .chats-menu-trigger { display:none; }\n.lkfr-app .notification-date-group { font-size:14px; color:var(--lkfr-muted); margin:18px 0 0; }\n@media(max-width:650px){.lkfr-app .chats-shell { height:calc(100dvh - 66px); border-radius:0; border:0; } .lkfr-app .chats-sidebar { height:100%; } .lkfr-app .chats-main { height:100%; } }\n.lkfr-app .chats-page { position:relative; inset:auto; height:auto; min-height:0; }\n.lkfr-app .chats-page { --tg-font-main:\"Cera Pro\",Arial,sans-serif; }\n.lkfr-app .chats-page[data-chat-theme=\"light\"] { --tg-accent:var(--lkfr-accent); --tg-link:#bd213a; --tg-bubble-mine:#ffedef; --tg-sidebar:#fff; --tg-wallpaper-base:#f4f6f8; }\n.lkfr-app .assistant-hub-chat { --tg-accent:var(--lkfr-accent); --tg-link:#bd213a; --tg-text:var(--lkfr-ink); }\n.lkfr-app .assistant-hub-chat .assistant-conversation { font-family:inherit; min-height:0; }\n.lkfr-app .assistant-hub-chat :is(.chats-primary,.chats-secondary,.chats-icon) { border:1px solid var(--lkfr-border); color:var(--lkfr-ink); background:#f2f5f8; box-shadow:none; border-radius:10px; padding:10px 12px; font-size:13px; cursor:pointer; }\n.lkfr-app .assistant-hub-chat .chats-primary { color:white; background:var(--lkfr-accent); border-color:var(--lkfr-accent); }\n.lkfr-app .assistant-hub-chat .assistant-composer textarea { font-size:14px; }\n.lkfr-app .assistant-hub-chat .assistant-intro { font-size:14px; }\n.lkfr-app .assistant-hub-chat .assistant-intro h3 { font-size:18px; }\n.lkfr-app .assistant-hub-chat .assistant-conversation-head .chat-avatar { width:38px; height:38px; font-size:13px; display:grid; place-items:center; border-radius:12px; background:var(--lkfr-accent-soft); color:var(--lkfr-accent); }\n.lkfr-app .assistant-hub-chat .assistant-messages { max-height:400px; min-height:200px; }\n@media(max-width:760px){.lkfr-app .chats-page .chats-shell { height:calc(100dvh - 66px); min-height:0; } .lkfr-app .chats-page .chats-main, .lkfr-app .chats-page .chats-sidebar { height:100%; } }\n\n/* Phone controls stay readable without triggering Safari's input zoom. */\n@media (max-width: 1099px) {\n  .lkfr-app :is(input, select, textarea) { font-size: 16px; }\n  .lkfr-app :is(.section-input, .section-select, .section-textarea, .business-page input, .business-page select, .business-page textarea, .assistant-composer textarea) { font-size: 16px; }\n  .lkfr-app :is(.ticket-chat-input, .timetable-input-group input), .lkfr-app .chats-page .composer-input { font-size: 16px; }\n  .lkfr-app .assistant-hub-chat .assistant-composer textarea, .lkfr-app .chats-page .chats-input { font-size: 16px; }\n  .lkfr-app .chats-page .chats-search { width: 100%; min-width: 0; }\n  .lkfr-app .chats-page :is(.chats-sidebar, .chats-main) { min-width: 0; }\n  .lkfr-app .chats-page .chats-sidebar-head { display: flex; justify-content: space-between; }\n  .lkfr-app .chats-page .chat-filter-chip { min-height: 44px; }\n  .lkfr-app .chats-page :is(.chats-round-action, .chats-icon) { min-width: 44px; min-height: 44px; }\n  .lkfr-app :is(input, select):not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"file\"]) { min-height: 44px; }\n  .lkfr-app .business-checklist label { min-height: 44px; }\n  .lkfr-app :is(input[type=\"checkbox\"], input[type=\"radio\"]) { min-height: 0; width: 20px; height: 20px; flex: 0 0 20px; accent-color: var(--lkfr-accent); }\n  .lkfr-app :is(.business-primary, .business-secondary, .section-btn, .section-btn-secondary, .section-btn-danger, .section-chip, .section-upload-remove, .notif-filter-btn, .records-filter-button, .lkfr-tabs button, .chats-icon, .chats-secondary, .chats-primary) { min-height: 44px; }\n  .lkfr-app .assistant-scope :is(input, select) { font-size: 16px; }\n  .lkfr-dialog { max-height: calc(100dvh - 32px); overflow-y: auto; padding: 20px; }\n  .lkfr-dialog-heading { align-items: center; }\n  .lkfr-dialog-heading button { width: 44px; height: 44px; flex: 0 0 auto; }\n  .lkfr-dialog-actions button { min-height: 44px; }\n  .lkfr-app .timetable :is(th, td).sticky-col { width: 110px; max-width: 110px; overflow-wrap: anywhere; }\n  .lkfr-app .timetable td { height: 48px; }\n  .lkfr-app[data-keyboard-open=\"true\"] .lkfr-bottom-nav { display: none; }\n  .lkfr-app .chats-page .chats-shell, .lkfr-app .ticket-chat-page { min-height: 0; height: calc(var(--lkfr-viewport-height, 100dvh) - var(--lkfr-header-height) - 44px); }\n  body.ticket-native-document .lkfr-app .ticket-chat-page { top: var(--lkfr-header-height); height: calc(var(--ticket-chat-viewport-height, var(--lkfr-viewport-height, 100dvh)) - var(--lkfr-header-height)); }\n}\n@media (max-width: 650px) {\n  .lkfr-app .terminal-marking-content { width: 100%; margin: 0; padding: 0; }\n  .lkfr-app .terminal-marking-header { align-items: flex-start; flex-direction: column; }\n  .lkfr-app .terminal-marking-header button { width: 100%; min-height: 44px; }\n  .lkfr-app .business-toolbar { align-items: stretch; }\n  .lkfr-app .business-toolbar > label { flex: 1 1 160px; min-width: 0; }\n  .lkfr-app .business-toolbar > :is(button, a) { flex: 1 1 auto; }\n  .lkfr-app .section-inline { flex-direction: column; grid-template-columns: minmax(0, 1fr); }\n  .lkfr-app .lkfr-inline-links a { display: flex; align-items: center; min-height: 44px; padding: 6px 10px; background: #fff; border: 1px solid var(--lkfr-border); border-radius: 10px; text-decoration: none; }\n  .lkfr-app .timetable-input-group:not(.timetable-checkbox-row) { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }\n  .lkfr-app .timetable-input-group:not(.timetable-checkbox-row) > span { display: none; }\n  .lkfr-app .timetable-input-group:not(.timetable-checkbox-row) label { display: grid; min-width: 0; }\n  .lkfr-app .timetable-input-group input[type=\"time\"] { min-width: 0; width: 100%; margin: 0; padding: 8px; }\n  .lkfr-app :is(.business-card, .section-card, .section-item) { min-width: 0; overflow-wrap: anywhere; }\n  .lkfr-app .notif-container { max-width: none; padding: 0; }\n  .lkfr-app [id] { scroll-margin-top: calc(var(--lkfr-header-height) + 12px); }\n  .lkfr-app .mobile-card-table { display: block; width: 100%; }\n  .lkfr-app .mobile-card-table thead { position: absolute; width: 1px; height: 1px; overflow: hidden; clip-path: inset(50%); }\n  .lkfr-app .mobile-card-table tbody { display: grid; gap: 12px; }\n  .lkfr-app .mobile-card-table tr { display: grid; gap: 8px; padding: 14px; border: 1px solid var(--lkfr-border); border-radius: 12px; }\n  .lkfr-app .mobile-card-table td { display: grid; grid-template-columns: minmax(80px, .8fr) minmax(0, 1fr); align-items: center; gap: 10px; border: 0; padding: 0; font-size: 14px; overflow-wrap: anywhere; }\n  .lkfr-app .mobile-card-table td::before { content: attr(data-label); color: var(--lkfr-muted); font-size: 12px; font-weight: 400; }\n  .lkfr-app .mobile-card-table td > span { min-width: 0; text-align: right; }\n  .lkfr-app .mobile-card-table td.mobile-table-actions { display: block; padding-top: 4px; }\n  .lkfr-app .mobile-card-table td.mobile-table-actions::before { content: none; }\n  .lkfr-app .mobile-card-table td.mobile-table-actions button { width: 100%; }\n  .lkfr-app .ticket-chat-page { min-height: 0; height: calc(var(--ticket-chat-viewport-height, var(--lkfr-viewport-height, 100dvh)) - var(--lkfr-header-height)); }\n  body.ticket-native-document .lkfr-app .ticket-chat-page { top: var(--lkfr-header-height); height: calc(var(--ticket-chat-viewport-height, var(--lkfr-viewport-height, 100dvh)) - var(--lkfr-header-height)); }\n}\n@media (max-width: 760px) {\n  .lkfr-app--conversation .lkfr-content { padding: 0; }\n  .lkfr-app .chats-page .chats-shell { grid-template-columns: minmax(0, 1fr); height: calc(var(--lkfr-viewport-height, 100dvh) - var(--lkfr-header-height)); }\n  .lkfr-app .chats-page .chats-sidebar { grid-template-columns: minmax(0, 1fr); }\n  .lkfr-app .ticket-chat-page { height: calc(var(--ticket-chat-viewport-height, var(--lkfr-viewport-height, 100dvh)) - var(--lkfr-header-height)); }\n}\n@media (max-width: 380px) { .lkfr-app .assistant-period { grid-template-columns: minmax(0, 1fr); } }\n\n.lkfr-messenger-icon { position: relative; display: flex; }\n.lkfr-app .lkfr-messenger-badge { position: absolute; top: -5px; right: -12px; min-width: 18px; height: 18px; padding: 0 4px; border-radius: 10px; color: white; background: var(--lkfr-accent); font-size: 10px; line-height: 18px; text-align: center; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
